export default {
  message: {
    ABOUT_THE_COMPANY: "Über die Gesellschaft",
    ADD_TO_FAVORITES: "Als Favorit merken",
    TARIFF_MARK_BOOKMARK: "Markieren",
    TARIFF_MARK_BOOKMARKED: "Markiert",
    TARIFF_MARK_ADD_NOTE: "Notiz hinzufügen",
    TARIFF_MARK_NOTE_PLACEHOLDER: "Notiz zum Tarif …",
    TARIFF_MARK_NOTE: "Notiz",
    TARIFF_MARK_NOTE_TITLE: "Notiz zu diesem Tarif",
    TARIFF_MARK_NOTE_SAVE: "Speichern",
    TARIFF_MARK_NOTE_REMOVE: "Notiz entfernen",
    TARIFF_MARK_NOTE_EDIT: "Bearbeiten",
    TARIFF_MARK_SEND_OFFER: "Markierte als Angebot versenden",
    TARIFF_MARK_SEND_OFFER_SHORT: "Als Angebot",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARK: "Tarif für Angebot auswählen",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARKED: "Auswahl aufheben",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE: "Notiz zum ausgewählten Tarif hinzufügen",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE_EDIT:
      "Notiz zum ausgewählten Tarif bearbeiten",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE: "Tarif zum Vergleich hinzufügen",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE_REMOVE:
      "Tarif aus dem Vergleich entfernen",
    TARIFF_SIDE_RAIL_TOOLTIP_PRINT: "Tarif drucken",
    TARIFF_SIDE_RAIL_TOOLTIP_CONTACTS: "Kontakte zum Tarif anzeigen",
    ADDITIONAL_FILTERS: "Zusätzliche Filter",
    ACCEPT: "Akzeptieren",
    ADDRESS_ERROR_MESSAGE: "Dies ist ein Pflichtfeld",
    ADDRESS_HOUSE_NUMBER_FORMAT_INVALID:
      "Das Format der Hausnummer ist ungültig",
    ADDRESS_SEARCH_PLACEHOLDER: "Suchen …",
    ADDRESS_STREET_NUMBER_PLACEHOLDER: "Nr.",
    ADDRESS_STREET_SELECT_FROM_LIST:
      "Bitte wählen Sie die Straße aus der Vorschlagsliste aus.",
    ADDRESS_VALIDATION_FAILED_CONTACT:
      "Die angegebene Adresse konnte nicht validiert werden. Bitte versuchen Sie es erneut oder wenden Sie sich an {supportEmail}",
    ADDRESS_SECTION: "Adresse",
    ADD_TARIFF: "Produkt hinzufügen",
    A11Y_COMPARE_ADDED: "{name} zum Vergleich hinzugefügt.",
    A11Y_COMPARE_REMOVED: "{name} aus dem Vergleich entfernt.",
    A11Y_TARIFF_CARD_FOOTER_ACTIONS: "Aktionen für Tarif {name}",
    A11Y_TARIFF_BROKER_ACTIONS: "Makler-Aktionen für Tarif",
    A11Y_TARIFF_SIDE_RAIL: "Aktionen zum Tarif",
    A11Y_SEARCH_RESULTS_COUNT:
      "{count} Tarif gefunden. | {count} Tarife gefunden.",
    A11Y_SEARCH_RESULTS_NONE: "Keine Tarife gefunden.",
    A11Y_STATEMENT_CONFORMANCE_BODY:
      "Diese Webanwendung strebt die Konformität mit WCAG 2.2 Stufe AA an. Der Stand der Umsetzung wird fortlaufend verbessert; bekannte Einschränkungen sind unten aufgeführt.",
    A11Y_STATEMENT_CONFORMANCE_HEADING: "Konformitätsstatus",
    A11Y_STATEMENT_ENFORCEMENT_BODY:
      "Bei nicht zufriedenstellenden Antworten können Sie sich an die Schlichtungsstelle nach dem Barrierefreiheitsstärkungsgesetz wenden.",
    A11Y_STATEMENT_ENFORCEMENT_HEADING: "Durchsetzungsverfahren",
    A11Y_STATEMENT_FEEDBACK_BODY:
      "Wenn Ihnen Barrieren auffallen, senden Sie uns bitte eine Nachricht an",
    A11Y_STATEMENT_FEEDBACK_HEADING: "Feedback und Kontakt",
    A11Y_STATEMENT_FEEDBACK_SUBJECT:
      "Feedback zur Barrierefreiheit – {brandName}",
    A11Y_STATEMENT_INTRO:
      "{brandName} ist bestrebt, den Vergleichsrechner und die Antragsstrecken barrierefrei zugänglich zu machen. Diese Erklärung wurde am {assessedDate} erstellt.",
    A11Y_STATEMENT_LIMITATION_ADS:
      "Eingeblendete Werbeanzeigen und Inhalte Dritter können Barrieren aufweisen.",
    A11Y_STATEMENT_LIMITATION_CHAT:
      "Der optionale Live-Chat (Freshchat) wird von einem Drittanbieter bereitgestellt.",
    A11Y_STATEMENT_LIMITATION_THIRD_PARTY:
      "White-Label-Einbettungen können abweichende Header-, Footer- und Hilfe-Elemente zeigen.",
    A11Y_STATEMENT_LIMITATIONS_HEADING: "Bekannte Einschränkungen",
    A11Y_STATEMENT_SCOPE_BODY:
      "In Scope sind die Tarifsuche, der Bedarfscheck, der Produktvergleich, die Antragsstrecke (Checkout) und die E-Mail-Verifizierung in dieser Anwendung.",
    A11Y_STATEMENT_SCOPE_HEADING: "Anwendungsbereich",
    A11Y_STATEMENT_TITLE: "Erklärung zur Barrierefreiheit",
    ALPHA_ASC: "A bis Z",
    ALPHA_ASC_MOBILE: "Gesellschaft (A bis Z)",
    ALPHA_DESC: "Z bis A",
    ALPHA_DESC_MOBILE: "Gesellschaft (Z bis A)",
    ALPHA_MAIN_LABEL: "Gesellschaft",
    ANNUAL_FEE: "Jahresbeitrag",
    APP_POPUP_DEFAULT_TITLE: "Hinweis",
    APP_POPUP_DISMISS_DEFAULT: "OK",
    APP_POPUP_NO_CONTENT: "Kein Inhalt verfügbar.",
    APP_TOAST_CLIPBOARD_TARIFF_FALLBACK: "Produkt: ({legacyId})",
    APP_TOAST_CLIPBOARD_TARIFF_LINE: "Produkt: {main} ({legacyId})",
    APP_TOAST_CLIPBOARD_TOKEN_LINE: "Token: {token}",
    APP_TOAST_CLIPBOARD_URL_LINE: "Seiten-URL: {url}",
    APP_TOAST_CONSOLE_SECTION_HEADER:
      "--- Letzte Konsolenausgabe (Fehler / Warnungen) ---",
    APP_TOAST_COPIED: "Kopiert",
    APP_TOAST_COPY_ERROR: "Fehlermeldung kopieren",
    APP_TOAST_EMAIL_REPORT: "Fehlerbericht per E-Mail senden",
    APP_TOAST_EMAIL_SUBJECT: "Fehlerbericht Buchung",
    APP_TOAST_SESSION_ID_LABEL: "Sitzung-ID:",
    APP_TOAST_TITLE_ERROR: "Fehler",
    APP_TOAST_TITLE_INFO: "Info",
    APP_TOAST_TITLE_SUCCESS: "Erfolg",
    APP_TOAST_TITLE_WARNING: "Hinweis",
    APPLY_CHANGES: "Änderungen übernehmen",
    ARIA_LABEL_CLOSE: "Schließen",
    ARIA_LABEL_CLEAR_FIELD: "Eingabe löschen",
    AWARDS: "Auszeichnungen",
    BACK: "Zurück",
    BACK_TOP_TOP: "Zurück nach oben",
    BACK_TO_SEARCH: "Zurück zur Suche",
    BEST_RATING: "Beste Bewertung",
    BOOK: "Jetzt beantragen",
    BOOK_SHORT: "Beantragen",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_TITLE: "Nur noch ein Schritt",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "Nach dem Klick auf <strong>„{cta}“</strong> senden wir Ihnen eine E-Mail an <strong>{email}</strong>. Klicken Sie darin auf den Link, um Ihren Antrag abzuschließen.<br/><br/><strong>Tipp:</strong> Prüfen Sie bei Bedarf auch Ihren Spam-Ordner. Eine spätere Änderung der E-Mail-Adresse ist leider nicht mehr möglich — bitte stellen Sie sicher, dass Sie Zugriff auf dieses Postfach haben.",
    INVITATIO_BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "Nach dem Klick auf <strong>„{cta}“</strong> senden wir Ihnen eine E-Mail an <strong>{email}</strong>. Klicken Sie darin auf den Link, um Ihre Anfrage abzuschließen.<br/><br/><strong>Tipp:</strong> Prüfen Sie bei Bedarf auch Ihren Spam-Ordner. Eine spätere Änderung der E-Mail-Adresse ist leider nicht mehr möglich — bitte stellen Sie sicher, dass Sie Zugriff auf dieses Postfach haben.",
    VERIFICATION_EMAIL_ADDRESS_LOCKED_NOTE:
      "Die Bestätigungs-E-Mail wurde an <strong>{email}</strong> gesendet. Diese Adresse kann nicht mehr geändert werden.",
    BOOKING_COMPLETED_INFO_1: `Ihr Versicherungsantrag ist erfolgreich bei uns eingegangen und Sie erhalten von uns in Kürze eine Bestätigung per E-Mail an <strong>{email}</strong>.
      Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.`,
    BOOKING_COMPLETED_INFO_2: `Bitte beachten Sie, dass der Versicherungsschutz erst in Kraft tritt, wenn die <strong>{name}</strong> Ihren
      Versicherungsantrag angenommen hat und die Erstprämie gezahlt ist.`,
    BOOKING_COMPLETED_INFO_4:
      "Ihr Antrag wird in unserem System unter der nachgenannten Kennung geführt. Bitte geben Sie diese bei allen Rückfragen stets an.",
    BOOKING_COMPLETED_INFO_5:
      "Hier finden Sie alle notwendigen Unterlagen zu Ihrem Antrag sowie weitere nützliche Links. Bitte beachten Sie, den Versicherungsschein erhalten Sie direkt vom Versicherungsunternehmen.",
    BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Hier finden Sie alle notwendigen Unterlagen zu Ihrem Antrag. Bitte beachten Sie, den Versicherungsschein erhalten Sie direkt vom Versicherungsunternehmen.",
    BOOKING_COMPLETED_PROTOCOL_LINK_LABEL: "{documentName} herunterladen",
    BOOKING_COULD_NOT_COMPLETE_RETRY:
      "Der Antrag konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
    BOOKING_SESSION_ALREADY_CONFIRMED:
      "Ihr Antrag ist bereits bei uns eingegangen. Sie müssen ihn nicht erneut absenden.",
    BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Ihr Antrag ist bereits bei uns eingegangen. Sie müssen ihn nicht erneut absenden. Antragsnummer: A-{bookingId}",
    BOOKING_EMAIL_FIELD_VALIDATION_FAILED:
      "Die angegebene E-Mail-Adresse konnte leider nicht validiert werden. Bitte verwenden Sie eine andere Adresse oder melden Sie sich bei uns: {supportEmail}",
    BOOKING_ENTITY_ADD: "+ {unit} hinzufügen",
    BOOKING_ENTITY_REMOVE: "{unit} {n} entfernen",
    BOOKING_ERROR_SUMMARY_TITLE: "Bitte korrigieren Sie die folgenden Angaben:",
    BOOKING_FOOTER_BADGE_SUBJECT_TO_INQUIRY: "anfragepflichtig",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_PAID: "Kostenpflichtig anfragen",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_SUBMIT: "Anfrage absenden",
    BOOKING_FOOTER_PRICE_ON_REQUEST: "nach Vereinbarung",
    BOOKING_LOADING_INSURED_PERSONS: "Versicherte Personen werden geladen …",
    BOOKING_TRANSITION_LOADING: "Das Formular wird geladen …",
    BOOKING_TRANSITION_LOADING_QUOTE: "Ihre Angebotsanfrage wird geladen …",
    BOOKING_TRANSITION_SUBMITTING: "Ihre Daten werden übertragen …",
    SEARCH_RESULTS_LOADING: "Suchergebnisse werden geladen …",
    BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "Die Verbindung wurde unterbrochen. Falls Ihr Antrag erfolgreich war, finden Sie die Bestätigung auf der nächsten Seite. Bitte überprüfen Sie dies.",
    BOOKING_PAGE_ONE_HEADING: "Ihre Angaben",
    BOOKING_SHUFFLE_ARIA: "Antragsformularfelder zufällig befüllen",
    BOOKING_SHUFFLE_LABEL: "Felder zufällig befüllen",
    BOOKING_SHUFFLE_CHECKBOXES_ARIA:
      "Alle Pflicht-Checkboxen auf der Antragsseite setzen",
    BOOKING_SHUFFLE_CHECKBOXES_LABEL: "Pflicht-Checkboxen setzen",
    BOOKING_SHUFFLE_OPTIONS_ARIA: "Spezialfälle für Zufallsbefüllung",
    BOOKING_SHUFFLE_OPTION_POLICYHOLDER_ADULT:
      "Versicherungsnehmer (Erwachsener)",
    BOOKING_SHUFFLE_OPTION_ALTERNATIVE_PAYER: "Abweichender Beitragszahler",
    BOOKING_PAGE_VALIDATION_UNAVAILABLE:
      "Die Validierung konnte nicht durchgeführt werden. Bitte versuchen Sie es erneut.",
    BOOKING_REFERENCE_PENDING: "wird erstellt",
    BOOKING_TOAST_JUMP_TO_FIRST_ERROR: "Zum ersten Fehler springen",
    BOOKING_VALIDATION_FAILED_WITH_SUPPORT:
      "Die Validierung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    BOOK_ANOTHER_CONTRACT: "Weiteren Antrag einreichen",
    BOOK_LAST_PAGE: "Kostenpflichtig beantragen",
    BROKER_ACCOUNT_SUSPENDED_BODY:
      "Diese Vermittlerkennung ist uns nicht bekannt oder wurde deaktiviert. Bitte wenden Sie sich an Ihren Vermittler oder schreiben Sie an {supportEmail}.",
    BROKER_ACCOUNT_SUSPENDED_TITLE: "Diese Vermittlerkennung wurde gesperrt",
    BROKER_CTA_HOLD_TOOLTIP:
      "Bitte tragen Sie zuerst Ihre Vermittlerkennung ein, damit Sie fortfahren können.",
    CALCULATOR_NOTE_LINK_TEXT: "Hinweise und teilnehmende Gesellschaften",
    CANCEL: "Abbruch",
    CANCEL_BUTTON: "Abbrechen",
    CHECKING_CONTRACT:
      "Wir prüfen Ihren Antrag und leiten ihn an das gewählte Versicherungsunternehmen weiter.",
    CLEAR_ALL: "Alle löschen",
    COMPANIES: "Gesellschaften",
    INSURER_TEASER_ARIA: "Versicherer mit Startpreis",
    INSURER_TEASER_SCROLL_LEFT: "Weitere Versicherer nach links",
    INSURER_TEASER_SCROLL_RIGHT: "Weitere Versicherer nach rechts",
    TARIFF_DETAILS_TABS_SCROLL_LEFT: "Weitere Produktdetails nach links",
    TARIFF_DETAILS_TABS_SCROLL_RIGHT: "Weitere Produktdetails nach rechts",
    COMPARISON_PAYMENT_OPTIONS_GENERIC_ERROR:
      "Die Zahlungsweisen konnten nicht geladen werden.",
    COMPARISON_PAYMENT_OPTIONS_LABEL: "Zahlungsweisen",
    COMPARISON_PAYMENT_OPTIONS_NOT_AVAILABLE: "Nicht verfügbar",
    COMPARISON_PAYMENT_OPTIONS_RETRY: "Erneut laden",
    COMPARISON_PAYMENT_OPTIONS_TIMEOUT_ERROR:
      "Die Zahlungsweisen konnten nicht geladen werden (Zeitüberschreitung). Bitte versuchen Sie es erneut.",
    COMPARISON_PAYMENT_SELECTED_LABEL: "Preis für gewählte Zahlungsweise",
    COMPARISON_PRODUCT_HIGHLIGHTS: "Highlights",
    COMPARISON_REMOVE_TARIFF: "Produkt aus dem Vergleich entfernen",
    CONTACT_LINK_TXT: "Kontakt",
    CONTINUE: "Weiter",
    CONTRACT_CANCELLATION: "Vertrag widerrufen",
    CONTRACT_DONE: "Ihr Antrag ist bei uns eingegangen",
    CONTRACT_DONE_TARIFF_INFO_TITLE: "Ihr beantragter Versicherungsschutz",
    CONTRACT_PROCESSING: "Antragsverarbeitung",
    CONTRACT_PROCESSING_TEXT:
      "Das Versicherungsunternehmen bearbeitet Ihren Antrag.",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_LABEL: "Antragsnummer",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_PLACEHOLDER: "z. B. 123456",
    CONTRACT_RENEWAL_BIRTH_DATE_LABEL: "Geburtsdatum",
    CONTRACT_RENEWAL_CONTINUE: "Fortfahren",
    CONTRACT_RENEWAL_INFORMATIVE:
      "Ich bestätige, die Erstinformation für Versicherungsvermittler gemäß § 15 VersVermV heruntergeladen und gelesen zu haben. {link}",
    CONTRACT_RENEWAL_INFORMATIVE_REQUIRED:
      "Bitte bestätigen Sie den Erhalt der Erstinformation.",
    CONTRACT_RENEWAL_INTRO:
      "Um fortfahren zu können, tragen Sie bitte die Antragsnummer, das Geburtsdatum und die Postleitzahl des Versicherungsnehmers ein, dessen Vertrag Sie verlängern möchten.",
    CONTRACT_RENEWAL_INVALID_APPLICATION_NUMBER:
      "Bitte geben Sie eine gültige Antragsnummer ein.",
    CONTRACT_RENEWAL_INVALID_POSTAL_CODE: "Ungültige Postleitzahl",
    CONTRACT_RENEWAL_LOADER_STEP_PREPARE: "Tarifrechner wird geladen",
    CONTRACT_RENEWAL_LOADER_STEP_READY: "Weiterleitung zur Tarifsuche",
    CONTRACT_RENEWAL_LOADER_STEP_VERIFY: "Antrag wird bestätigt",
    CONTRACT_RENEWAL_LOADER_SUBTITLE: "Bitte warten Sie einen Moment.",
    CONTRACT_RENEWAL_LOADER_TITLE: "Ihr Vertrag wird vorbereitet",
    CONTRACT_RENEWAL_POSTAL_CODE_LABEL: "Postleitzahl",
    CONTRACT_RENEWAL_POSTAL_CODE_PLACEHOLDER: "z. B. 60327",
    CONTRACT_RENEWAL_TITLE: "Bestätigung erforderlich",
    CONTRACT_SUBMISSION: "Antragsübermittlung",
    CORONA_CANCELLATION_DAFAULT_TOOLTIP:
      "<b>Reiserücktritt / Reiseabbruch</b><br>Bei diesem Produkt sind Sie oder die Risikoperson abgesichert, wenn Sie sich mit COVID-19 / dem Coronavirus infizieren und vor Reiseantritt einen positiven Corona-Test vorweisen können. Bitte beachten Sie, dass alleine die Angst vorm Verreisen oder einer Corona-Infektion nicht versichert ist.",
    CORONA_HEALTH_DAFAULT_TOOLTIP:
      "<b>Reisekranken</b><br>Bei diesem Produkt Sie sind abgesichert, wenn Sie während der Reise an COVID-19 / dem Coronavirus erkranken und medizinisch behandelt werden müssen. Mehrkosten, die Ihnen aufgrund von Quarantänemaßnahmen (bspw. für Unterkunft) entstehen, sind nicht versichert.",
    CORONA_INSURED: "Corona abgesichert",
    CORONA_NOT_INSURED: "Corona nicht abgesichert",
    CORONA_PARTIALLY_INSURED: "Corona-Hinweis beachten!",
    CORONA_TAG_HEADING_CANCEL: "Reiserücktritt / Reiseabbruch",
    CORONA_TAG_HEADING_HEALTH: "Reisekranken",
    COVERAGE_FEATURES: "Leistungsmerkmale",
    DATA_PROTECTION: "Datenschutz",
    DOCUMENTS: "Dokumente",
    DOCUMENTS_LOADING: "Dokumente werden geladen …",
    DOWNLOAD: "Herunterladen",
    DOWNLOAD_ALL: "Alle Dokumente als ZIP-Datei herunterladen",
    DOWNLOAD_PROTOCOL: "Beratungsprotokoll herunterladen",
    EMAIL_ADDRESS: "E-Mail-Adresse",
    EMAIL_ADDRESS_OF_THE_RECIPIENT: "Empfänger",
    CC: "IN KOPIE",
    EMAIL_FORM_PLACEHOLDER: "z. B. max.mustermann{'@'}example.com",
    EMAIL_FORM_CC_HELPER: "Mehrere Adressen mit Enter bestätigen",
    EMAIL_FORM_CC_PLACEHOLDER: "Eine oder mehrere Adressen hinzufügen …",
    EMAIL_FORM_FIELD_EMAIL: "E-Mail",
    EMAIL_FORM_MESSAGE_LABEL: "Nachricht",
    EMAIL_IS_REQUIRED: "E-Mail ist ein Pflichtfeld",
    ENTER_CORRECT_EMAIL: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    FILE_UPLOAD: "Datei auswählen",
    FILE_UPLOAD_SMARTPHONE: "Mit Smartphone hochladen",
    FILE_UPLOAD_SMARTPHONE_TITLE: "Dokument mit dem Smartphone hochladen",
    FILE_UPLOAD_SMARTPHONE_DESCRIPTION:
      "QR-Code mit der Smartphone-Kamera scannen. Die mobile Seite öffnet genau dieses Upload-Feld; eine Anmeldung ist nicht nötig.",
    FILE_UPLOAD_SMARTPHONE_ACTIVE: "Aktiv · noch {time} Min.",
    FILE_UPLOAD_SMARTPHONE_ACTIVE_SECONDS: "Aktiv · noch {time} Sek.",
    FILE_UPLOAD_SMARTPHONE_EXPIRED: "QR-Code abgelaufen",
    FILE_UPLOAD_SMARTPHONE_CLOSE: "QR-Code schließen",
    FILE_UPLOAD_SMARTPHONE_REFRESH: "QR-Code erneuern",
    FILE_UPLOAD_SMARTPHONE_WAITING: "Warte auf Smartphone-Upload…",
    FILE_UPLOAD_SMARTPHONE_UPLOADED: "Per Smartphone hochgeladen",
    FILE_UPLOAD_SMARTPHONE_SUCCESS_TITLE: "Dokument erfolgreich übernommen",
    FILE_UPLOAD_SMARTPHONE_UPLOADED_AT: "Hochgeladen am {date}",
    FILE_UPLOAD_SMARTPHONE_FILE_SIZE: "Dateigröße: {size}",
    FILE_UPLOAD_SMARTPHONE_REPLACE: "Ersetzen",
    FILE_UPLOAD_REMOVE: "Datei {fileName} entfernen",
    FILE_UPLOAD_SUCCESS: "Datei {fileName} wurde hochgeladen",
    FILE_ERROR_MAX_COUNT:
      "Es kann maximal {count} Datei hochgeladen werden. | Es können maximal {count} Dateien hochgeladen werden.",
    FILE_ERROR_SIZE:
      "Die ausgewählte Datei ist zu groß. Maximale Dateigröße: {maxSizeMb} MB.",
    FILE_ERROR_FORMAT:
      "Das ausgewählte Dateiformat ist nicht zulässig. Erlaubte Dateitypen: {allowedTypes}.",
    FILTERS: "Filter",
    FILTER_ACTION: "Filtern",
    FILTER_BY: "Filtern nach:",
    CLEAR: "Löschen",
    LINKS: "Links",
    RESULTS_CONTROLS_TOOLBAR: "Ergebnisse sortieren und filtern",
    FOOTER_ACCESSIBILITY_LINK: "Barrierefreiheit",
    FOOTER_AGB_LINK: "AGB",
    FOOTER_COOKIES_LINK: "Cookies",
    FOOTER_COPYRIGHT: "© {brandName}",
    FOOTER_MORE_LINKS: "Weitere Links",
    FORM_CONTAINS_ERRORS_TEXT:
      "Das Formular enthält Fehler. Beheben Sie die Fehler, um fortzufahren.",
    BOOKING_FOOTER_ERROR_HINT_TOOLTIP:
      "Es gibt Fehler im Formular. Klicken Sie hier, um zum ersten Fehler zu springen.",
    BOOKING_FOOTER_ERRORS_FOUND_ONE: "1 Problem gefunden",
    BOOKING_FOOTER_ERRORS_FOUND_MANY: "{count} Probleme gefunden",
    BOOKING_FOOTER_LANDMARK_LABEL: "Tarif und Antragsnavigation",
    EARLIEST_POSSIBLE_START: "frühestmöglicher Beginn",
    EARLIEST_POSSIBLE: "frühestmöglich",
    FROM: "ab",
    FULLY_CONTAINED: "Enthalten",
    GENERAL_BOOKING_ERROR:
      "Bei der Übermittlung der Daten ist ein Fehler aufgetreten.",
    GET_QUOTES_NOW: "Jetzt suchen",
    GROUP_TRAVEL_AGE_GROUPS_TOOLTIP:
      "Gruppen-Reiseversicherungen gelten für Gruppen ab 10 Personen (bei Bahnreisen ab 6 Personen) bis max. 150 Personen. Bitte unterscheiden Sie bei der Eingabe nach dem Alter der Reisenden.<br> Ausschlaggebend ist das <u>Alter bei Versicherungsabschluss.</u>",
    IBAN_VALIDATION_FAILED: "Bitte geben Sie eine gültige IBAN an",
    R_PARAMETER_VALIDATION_EMPTY:
      "Die Vermittlerkennung fehlt. Bitte überprüfen Sie den Link.",
    R_PARAMETER_VALIDATION_INVALID_FORMAT:
      "Die Vermittlerkennung hat ein ungültiges Format. Bitte überprüfen Sie den Link.",
    R_PARAMETER_VALIDATION_INACTIVE_AFFILIATE:
      "Die Vermittlerkennung ist nicht mehr aktiv. Bitte überprüfen Sie den Link.",
    R_PARAMETER_VALIDATION_LOOKUP_FAILED:
      "Die Vermittlerkennung konnte nicht gefunden werden. Bitte überprüfen Sie den Link.",
    R_PARAMETER_VALIDATION_PROCESSING:
      "Die Vermittlerkennung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
    R_PARAMETER_VALIDATION_RAW_AFFILIATE_ID:
      "Die Vermittlerkennung wurde in einem falschen Format übertragen. Dieses Format wird zukünftig nicht mehr unterstützt. Bitte informieren Sie den Vermittler. Ein Abschluss ist trotzdem möglich.",
    R_PARAMETER_VALIDATION_FAILED:
      "Die Vermittlerkennung ist ungültig. Bitte informieren Sie den Vermittler.",
    RESUME_BOOKING_CONFIRM_KICKER: "Ihr Antragsentwurf",
    RESUME_BOOKING_CONFIRM_TITLE_PREFIXED: "Antragsentwurf: {title}",
    RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "Zum Schutz Ihres Antragsentwurfs senden wir Ihnen einen Bestätigungscode per E-Mail.",
    RESUME_BOOKING_CONFIRM_EMAIL_LOADING_DESCRIPTION:
      "Wir prüfen, an welche E-Mail-Adresse der Bestätigungscode gesendet wird …",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION_GENERIC:
      "Der Bestätigungscode wird per E-Mail gesendet. Bitte warten Sie. Sie werden gleich zur Eingabe weitergeleitet.",
    RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Geben Sie Ihre E-Mail-Adresse ein, die mit diesem Antragsentwurf verknüpft ist. An diese E-Mail-Adresse senden wir Ihnen einen Einmal-Code für den Zugriff auf den Antragsentwurf.",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION:
      "Der Bestätigungscode wird an {email} gesendet. Bitte warten Sie. Sie werden gleich zur Eingabe weitergeleitet.",
    RESUME_BOOKING_CONFIRM_CODE_PLACEHOLDER: "Zugangscode",
    RESUME_BOOKING_CONFIRM_EMAIL_HINT: "Einmal-Code geht an {email}",
    RESUME_BOOKING_LOADER_ERROR_TITLE:
      "Dieser Schritt konnte nicht abgeschlossen werden",
    RESUME_BOOKING_LOADER_ERROR_SESSION_COMPLETED:
      "Diese Buchung wurde bereits abgeschlossen. Der Einladungslink ist daher nicht mehr gültig.",
    RESUME_BOOKING_LOADER_ERROR_SESSION:
      "Der gespeicherte Antragsentwurf konnte nicht geladen werden.",
    RESUME_BOOKING_LOADER_ERROR_SEARCH_FORM:
      "Die Suchmaske konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
    RESUME_BOOKING_LOADER_ERROR_TARIFFS:
      "Der ausgewählte Tarif ist leider nicht mehr verfügbar. Alternativ können Sie eine neue Tarifsuche starten.",
    RESUME_BOOKING_LOADER_ERROR_BOOKING_FORM:
      "Das Buchungsformular konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
    RESUME_BOOKING_LOADER_ERROR_GENERIC:
      "Beim Fortsetzen Ihrer Buchung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_LINK: "Neuen Tarif suchen",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_HINT:
      "Alternativ können Sie eine neue Tarifsuche starten.",
    RESUME_BOOKING_VERIFY_TITLE: "Einmal-Code eingeben",
    RESUME_BOOKING_VERIFY_DESCRIPTION:
      "Der Einmal-Code wurde an {email} gesendet. Bitte prüfen Sie Ihr E-Mail-Postfach und geben Sie den 9-stelligen Einmal-Code unten ein.",
    RESUME_BOOKING_VERIFY_DESCRIPTION_PENDING:
      "Fordern Sie zuerst einen Einmal-Code an. Danach können Sie den 9-stelligen Einmal-Code hier eingeben.",
    RESUME_BOOKING_VERIFY_CODE_ARIA_LABEL: "9-stelliger Bestätigungscode",
    RESUME_BOOKING_VERIFY_BUTTON: "Einmal-Code bestätigen",
    RESUME_BOOKING_VERIFY_ERROR_TITLE: "Verifizierung fehlgeschlagen",
    RESUME_BOOKING_VERIFY_ERROR_BODY:
      "Bitte prüfen Sie den eingegebenen Einmal-Code oder fordern Sie einen neuen Einmal-Code an.",
    RESUME_BOOKING_VERIFY_CODE_EXPIRY:
      "Der Einmal-Code ist noch {time} gültig.",
    RESUME_BOOKING_VERIFY_RESEND_QUESTION: "Einmal-Code nicht erhalten?",
    RESUME_BOOKING_VERIFY_RESEND_BUTTON: "Neuen Einmal-Code senden.",
    REQUEST_OTP_LOCKED_ERROR_BODY:
      "Zu viele fehlgeschlagene Eingaben. Bitte warten Sie noch {seconds} Sekunden, bevor Sie einen neuen Einmal-Code anfordern.",
    REQUEST_OTP_RATE_LIMITED_ERROR_BODY:
      "Sie haben bereits einen Einmal-Code angefordert. Bitte warten Sie noch {seconds} Sekunden, bevor Sie einen neuen Einmal-Code anfordern.",
    REQUEST_CODE: "Einmal-Code anfordern",
    VERIFY_OTP_BLANK_ERROR_BODY: "Bitte geben Sie den Bestätigungscode ein.",
    VERIFY_OTP_INVALID_ERROR_BODY:
      "Der eingegebene Einmal-Code ist ungültig. Bitte prüfen Sie den Einmal-Code in Ihrer E-Mail und versuchen Sie es erneut.",
    VERIFY_OTP_INVALID_LOCKED_ERROR_BODY:
      "Zu viele Versuche. Bitte versuchen Sie es in {time} erneut.",
    VERIFY_OTP_LOCKED_ERROR_BODY:
      "Zu viele Versuche. Bitte versuchen Sie es in {time} erneut.",
    VERIFY_OTP_ALREADY_CONSUMED_ERROR_BODY:
      "Dieser Einmal-Code wurde bereits verwendet. Bitte fordern Sie einen neuen Einmal-Code an.",
    VERIFY_OTP_NO_ACTIVE_OTP_ERROR_BODY:
      "Es wurde kein aktiver Einmal-Code gefunden. Bitte fordern Sie einen neuen Einmal-Code an.",
    VERIFY_OTP_EXPIRED_ERROR_BODY:
      "Der eingegebene Einmal-Code ist abgelaufen. Bitte fordern Sie einen neuen Einmal-Code an und versuchen Sie es erneut.",
    VERIFY_OTP_RATE_LIMITED_ERROR_BODY:
      "Bitte warten Sie noch {seconds} Sekunden, bevor Sie einen neuen Einmal-Code anfordern.",
    IMPORTANT_INFORMATION: "Wichtige Informationen",
    IMPORTANT_NOTES: "Wichtige Hinweise",
    IMPORTANT_NOTICE: "Wichtiger Hinweis",
    IMPORTANT_PRE_REQUIREMENTS: "Besondere Voraussetzungen",
    IMPRINT: "Impressum",
    INACTIVE_TARIFFS_LEARN_MORE: "Mehr erfahren …",
    INACTIVE_TARIFFS_MODAL_TITLE: "Vorübergehend nicht verfügbare Produkte",
    INACTIVE_TARIFFS_NOTICE_MULTIPLE:
      "Hinweis: {count} Produkte können Sie vorübergehend nicht über uns beantragen.",
    INACTIVE_TARIFFS_NOTICE_SINGLE:
      "Hinweis: Ein Produkt können Sie vorübergehend nicht über uns beantragen.",
    INFO: "Info",
    CONTACTS: "Kontakt",
    INFO_LINK_TEXT_SHORT: "Erstinformation",
    INITIAL_INFORMATION_LINK: "Erstinformation nach § 15 VersVermV",
    INSURANCES: "Versicherer",
    INSURANCE_POLICY: "Versicherungsschein",
    INSURANCE_POLICY_TEXT:
      "Das Versicherungsunternehmen sendet Ihnen (dem/der Versicherungsnehmer/-in) die Vertragsunterlagen per Post oder E-Mail zu.",
    INVITATIO_BOOKING_COMPLETED_INFO_1: `Ihre Anfrage ist erfolgreich bei uns eingegangen und Sie erhalten von uns in Kürze eine Bestätigung per E-Mail an <strong>{email}</strong>.
      Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.`,
    INVITATIO_BOOKING_COMPLETED_INFO_2:
      "Bitte beachten Sie, dass ein Versicherungsschutz erst entsteht, wenn die <strong>{name}</strong> Ihre Anfrage annimmt und die Erstprämie gezahlt ist.",
    INVITATIO_BOOKING_COMPLETED_INFO_4:
      "Ihre Anfrage wird in unserem System unter der nachgenannten Kennung geführt. Bitte geben Sie diese bei allen Rückfragen stets an.",
    INVITATIO_BOOKING_COMPLETED_INFO_5:
      "Hier finden Sie alle notwendigen Unterlagen zu Ihrer Anfrage sowie weitere nützliche Links. Bitte beachten Sie, den Versicherungsschein erhalten Sie direkt vom Versicherungsunternehmen.",
    INVITATIO_BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Hier finden Sie alle notwendigen Unterlagen zu Ihrer Anfrage. Bitte beachten Sie, den Versicherungsschein erhalten Sie direkt vom Versicherungsunternehmen.",
    INVITATIO_BOOKING_COULD_NOT_COMPLETE_RETRY:
      "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED:
      "Ihre Anfrage ist bereits bei uns eingegangen. Sie müssen sie nicht erneut absenden.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Ihre Anfrage ist bereits bei uns eingegangen. Sie müssen sie nicht erneut absenden. Anfragenummer: A-{bookingId}",
    INVITATIO_BOOKING_FOOTER_PRICE_ON_REQUEST: "auf Anfrage",
    INVITATIO_BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "Die Verbindung wurde unterbrochen. Falls Ihre Anfrage erfolgreich war, finden Sie die Bestätigung auf der nächsten Seite. Bitte überprüfen Sie dies.",
    INVITATIO_BOOK_ANOTHER_CONTRACT: "Weitere Anfrage stellen",
    INVITATIO_BOOK_LAST_PAGE: "Anfrage absenden",
    INVITATIO_CHECKING_CONTRACT:
      "Wir prüfen Ihre Anfrage und leiten sie an das gewählte Versicherungsunternehmen weiter.",
    INVITATIO_CONTRACT_DONE: "Ihre Anfrage ist bei uns eingegangen",
    INVITATIO_CONTRACT_DONE_TARIFF_INFO_TITLE:
      "Ihr gewünschter Versicherungsschutz",
    INVITATIO_CONTRACT_PROCESSING: "Policierung",
    INVITATIO_CONTRACT_PROCESSING_TEXT:
      "Das Versicherungsunternehmen bearbeitet Ihre Anfrage.",
    INVITATIO_CONTRACT_SUBMISSION: "Prüfung Anfrage",
    INVITATIO_INSURANCE_POLICY: "Versicherungsschein",
    INVITATIO_INSURANCE_POLICY_TEXT:
      "Das Versicherungsunternehmen informiert Sie nach Prüfung Ihrer Anfrage über die weiteren Schritte und sendet Ihnen gegebenenfalls die Vertragsunterlagen per Post oder E-Mail zu.",
    INVITATIO_PLEASE_WAIT_CONTRACT_NUM:
      "Bitte warten Sie, bis Ihre Anfragenummer erstellt wurde.",
    INVITATIO_TARIFF_BLOCK_BOOK: "Anfrage stellen",
    INVITATIO_VERIFICATION_ALREADY_VERIFIED_P1:
      "Ihre E-Mail-Adresse wurde bereits bestätigt. Ihre Anfrage mit der Kennung <strong>{bookingId}</strong> ist erfolgreich bei uns eingegangen.",
    INVITATIO_VERIFICATION_BOOKING_PENDING_BODY:
      "Um uns abschließend mit der Weiterleitung Ihrer Anfrage mit der Kennung <strong>{bookingData}</strong> an die <strong>{insurerName}</strong> zu beauftragen, klicken Sie bitte auf den <strong>Link „E-Mail-Adresse bestätigen“</strong> in der E-Mail, die wir soeben an <strong>{email}</strong> gesendet haben. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    INVITATIO_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ihre Anfrage wird nur dann von uns weitergeleitet, wenn Sie die E-Mail-Bestätigung erfolgreich durchführen.",
    INVITATIO_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Der Link zur Bestätigung Ihrer Anfrage mit der Kennung <strong>{bookingId}</strong> ist nicht mehr gültig. Ihre Anfrage wird von uns nicht weiterverarbeitet.",
    INVITATIO_VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Bitte beachten:</strong> Wir weisen Sie darauf hin, dass Versicherungsschutz erst dann besteht, wenn die <strong>{insurerName}</strong> Ihre Anfrage annimmt und bestätigt. Es gilt nur der in den Versicherungsbedingungen angegebene Versicherungsschutz. Die von uns ausgewiesenen Leistungsmerkmale werden nach bestem Wissen und Gewissen aktualisiert. Für Ihren Versicherungsvertrag gilt dennoch ausschließlich der in den Versicherungsbedingungen angegebene Leistungsumfang.",
    INVITATIO_VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Ihre Anfrage mit der Kennung <strong>{bookingId}</strong> ist erfolgreich bei uns eingegangen. Sie erhalten von uns in Kürze eine Bestätigung per E-Mail an <strong>{policyHolderEmail}</strong>. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    INVITATIO_VERIFICATION_SUCCESS_TITLE:
      "Ihre Anfrage wird nun von uns bearbeitet",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_BODY:
      "Der ursprünglich gewählte Versicherungsbeginn ist für diesen Tarif nicht mehr verfügbar. Ihre Anfrage kann nur mit einem neuen Versicherungsbeginn und dem angepassten Beitrag fortgesetzt werden.",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Erst nach Ihrer Bestätigung wird die Anfrage weiterverarbeitet.",
    INVITATIO_VERIFICATION_POLICY_START_BOOKING_LABEL: "Anfragenummer: ",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Bitte bestätigen Sie uns, dass die Beiträge per SEPA-Lastschrift von Ihrem Konto eingezogen werden dürfen. Klicken Sie dazu in der an <strong>{email}</strong> versandten E-Mail auf den vorgesehenen Bestätigungslink (z. B. <strong>„SEPA-Bestätigung“</strong>). Dabei beziehen wir uns auf Ihre Anfrage <strong>{bookingData}</strong> bei <strong>{insurerName}</strong>. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ohne rechtzeitige SEPA-Mandatsbestätigung ist die Beitragseinziehung per Lastschrift nicht möglich. Ihre Anfrage wird von uns nur weiterverarbeitet, nachdem die Bestätigung erfolgreich erfolgt ist.",
    INVITATIO_SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Der Link zur Bestätigung des SEPA-Lastschriftmandats zu der Angebotsanfrage mit der Kennung <strong>{bookingId}</strong> ist nicht mehr gültig.",
    INVITATIO_SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "Das SEPA-Lastschriftmandat zur Angebotsanfrage mit der Kennung <strong>{bookingId}</strong> wurde bereits bestätigt.",
    INVITATIO_SEPA_VERIFICATION_SUCCESS_MESSAGE:
      "<p>Das SEPA-Lastschriftmandat zur Angebotsanfrage mit der Kennung <strong>{bookingId}</strong> wurde für Sie hinterlegt.</p><p>Danke, dass Sie dem Einzug der Beiträge zugestimmt haben.</p><p>Ihr Vertrag kommt rechtswirksam ab dem ersten Beitrag zustande.</p>",
    RESUME_BOOKING_VERIFY_RESEND_COUNTDOWN: "Erneut senden in {time}",
    RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "Der gespeicherte Antragsentwurf wurde nicht gefunden oder gelöscht.",
    RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "Dieser gespeicherte Antragsentwurf ist abgelaufen.",
    RESUME_BOOKING_LOADER_TITLE: "Ihr Antragsentwurf wird vorbereitet",
    RESUME_BOOKING_LOADER_SUBTITLE:
      "Bitte warten Sie, während wir Ihren gespeicherten Antragsentwurf laden.",
    RESUME_BOOKING_LOADER_STEP_SESSION: "Daten werden geladen",
    RESUME_BOOKING_LOADER_STEP_SEARCH_FORM: "Suchmaske wird geladen",
    RESUME_BOOKING_LOADER_STEP_TARIFFS: "Tarife werden gesucht",
    RESUME_BOOKING_LOADER_STEP_BOOKING_FORM: "Formular wird vorbereitet",
    SAVE_AND_SEND: "Speichern und senden",
    SAVE_NOW: "Jetzt speichern",
    SAVED_SESSION: "Gespeichert. Link zum Fortsetzen: {resumeUrl}",
    SAVE_SESSION_COMPLETED_COPIED: "Link kopiert",
    SAVE_SESSION_COMPLETED_COPY_LINK: "Link kopieren",
    SAVE_SESSION_COMPLETED_EMAIL_SENT: "Bestätigung an {email} gesendet",
    SAVE_SESSION_COMPLETED_LINK_LABEL: "Link zum Antragsentwurf",
    SAVE_SESSION_COMPLETED_TITLE: "Erfolgreich gespeichert",
    SAVE_SESSION_DEFAULT_TITLE: "Meine {appName}-Versicherung",
    SAVE_SESSION_EMAILS: "E-Mail-Adressen",
    SAVE_SESSION_EMAIL_PLACEHOLDER: "Weitere E-Mail eingeben …",
    SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Gespeicherte Antragsentwürfe werden automatisch nach 30 Tagen ohne Aktivität gelöscht.",
    SAVE_SESSION_INSURER_FALLBACK: "Versicherer",
    SAVE_SESSION_NOT_TRANSMITTED:
      "Der Antrag wurde noch nicht an den zuständigen Versicherer übermittelt.",
    SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Bitte beachten:</strong> Es handelt sich um einen gespeicherten Entwurf zu einem Versicherungsantrag. Ein rechtsverbindlicher Antrag kommt erst zustande, wenn Sie den Antrag über die Schaltfläche „{submitButton}“ absenden. Dieses Speichern begründet noch kein Vertragsverhältnis. Versicherungsschutz besteht erst, wenn die <strong>{insurerName}</strong> Ihren Antrag ausdrücklich angenommen hat.",
    SAVE_SESSION_NO_PARTICIPANTS: "Noch keine Personen hinzugefügt.",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_LABEL:
      "Andere Personen über Änderungen informieren",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_QUESTION:
      "Möchten Sie die teilnehmenden Personen über Ihre Änderungen benachrichtigen?",
    SAVE_SESSION_NOTIFY_SEND: "Absenden",
    SAVE_SESSION_NOTIFY_NOW: "Jetzt benachrichtigen",
    SAVE_SESSION_NOTIFY_SENT_LABEL: "Benachrichtigt",
    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_TITLE: "E-Mail wurde versendet",

    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_BODY:
      "Die E-Mail wurde an alle Personen versendet und die Buchung wurde gespeichert.",

    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_TITLE:
      "E-Mail konnte nicht versendet werden",

    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_BODY:
      "Die Buchung konnte nicht gespeichert oder die Teilnehmer konnten nicht benachrichtigt werden. Bitte versuchen Sie es erneut.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_SUCCESS:
      "Die Teilnehmer wurden per E-Mail informiert.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_ERROR:
      "Die Änderungen wurden gespeichert, aber die Teilnehmer konnten nicht informiert werden.",
    SAVE_SESSION_PARTICIPANT_TITLE: "Teilnehmer/-in {number}",
    SAVE_SESSION_REMOVE_PARTICIPANT: "Teilnehmer/-in {number} entfernen",
    SAVE_SESSION_EDIT_PARTICIPANT: "Teilnehmer/-in {number} bearbeiten",
    SAVE_SESSION_DONE: "Fertig",
    SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "Der vorgenannte Vermittler erhält Zugriff auf diesen von Ihnen gespeicherten Antragsentwurf. Sie können diese Option jederzeit wieder deaktivieren.",
    SAVE_SESSION_SHARE_WITH_BROKER:
      "{brokerName} Zugriff auf meinen gespeicherten Antragsentwurf gestatten",
    SAVE_SESSION_NOTE: "Anmerkung",
    SAVE_SESSION_NOTE_ADD: "Erweiterte Einstellungen",
    SAVE_SESSION_NOTE_PLACEHOLDER: "Persönliche Notiz oder Hinweis",
    SAVE_SESSION_PARTICIPANTS: "Teilnehmer",
    SAVE_SESSION_INVITE_PEOPLE: "Personen einladen",
    SAVE_SESSION_INVITE_BUTTON: "Einladen",
    SAVE_SESSION_ADD_ANOTHER_PERSON: "Weitere Person einladen",
    SAVE_SESSION_SEND_INVITATION: "Einladung versenden",
    SAVE_SESSION_NEW_INTRO:
      "Speichern Sie Ihren Antrag als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link senden.",
    SAVE_SESSION_NEW_INTRO_BROKER:
      "Speichern Sie Ihren Antrag als Entwurf. Geben Sie einen Titel ein – der Entwurf erscheint anschließend in Ihrer Entwurfsübersicht im Vertriebsportal.",
    SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Speichern Sie Ihren Antrag als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link senden. Anschließend können Sie auch andere Personen zu Ihrem Antrag einladen.",
    SAVE_SESSION_EDIT_TITLE: "Titel bearbeiten",
    SAVE_SESSION_EDIT_NOTE: "Anmerkung bearbeiten",
    SAVE_SESSION_PARTICIPANTS_INTRO:
      "Laden Sie weitere Personen ein, damit diese Ihren Antragsentwurf ansehen, bearbeiten oder absenden können. Jede E-Mail-Adresse kann nur einmal verwendet werden.",
    SAVE_SESSION_PARTICIPANTS_HELPER:
      "Alle Teilnehmer erhalten einen Link per E-Mail und können den Antragsentwurf öffnen.",
    SAVE_SESSION_PARTICIPANTS_HINT:
      "(E-Mail-Adressen, eine pro Zeile oder per Komma)",
    SAVE_SESSION_TITLE: "Titel",
    SAVE_SESSION_TITLE_REQUIRED: "Bitte geben Sie einen Titel ein.",
    SAVE_SESSION_EMAIL_REQUIRED: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    SAVE_SESSION_MANAGE_TITLE: "Entwurf verwalten",
    SAVE_SESSION_MANAGE_DESCRIPTION:
      "Möchten Sie Teilnehmer, Berechtigungen oder Zugriffslinks verwalten? Öffnen Sie dazu die Verwaltung des Antragsentwurfs.",
    SAVE_SESSION_SHARE_TITLE: "Entwurf teilen",
    SAVE_SESSION_SHARE_MENU_SHARE: "Entwurf teilen",
    SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION: "Entwurf bearbeiten",
    SAVE_SESSION_SHARE_MENU_MANAGE_ACCESS: "Zugriff bearbeiten",
    SAVE_SESSION_EDIT_CALCULATION_TITLE: "Entwurf bearbeiten",
    SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Ändern Sie Titel und Anmerkung Ihres gespeicherten Antragsentwurfs.",
    SAVE_SESSION_MANAGE_ACCESS_TITLE: "Zugriff bearbeiten",
    SAVE_SESSION_MANAGE_ACCESS_INTRO:
      "Verwalten Sie den Zugang und die Berechtigungen für die teilnehmenden Personen. Jede E-Mail-Adresse kann nur einmal verwendet werden – auch die des/der Besitzers/-in lässt sich nicht erneut einladen. E-Mail-Adressen können nach dem Einladen nicht mehr geändert werden; entfernen Sie die Person bei Bedarf und laden Sie sie neu ein.",
    SAVE_SESSION_EMAIL_ALREADY_USED:
      "Diese E-Mail-Adresse wird bereits verwendet.",
    SAVE_SESSION_SAVE_TITLE: "Entwurf speichern",
    SAVE_SESSION_TITLE_HELPER:
      "Wählen Sie einen einprägsamen Titel für Ihren Antragsentwurf oder lassen Sie sich einen Titel vorschlagen. Den Titel Ihres Antragsentwurfs können Sie später ändern.",
    SAVE_SESSION_UPDATE_OWNER_LINK: "Besitzer-Link zum Antragsentwurf",
    SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "Über diesen Link kann der/die Besitzer/-in den Antragsentwurf direkt öffnen und verwalten.",
    SAVE_SESSION_UPDATE_GENERAL_LINK: "Allgemeiner Link zum Antragsentwurf",
    SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Geben Sie eine in diesem Antragsentwurf gespeicherte E-Mail-Adresse ein. Sie erhalten dann eine E-Mail an diese Adresse – über den Link in der E-Mail können Sie den Antragsentwurf öffnen.",
    SAVE_SESSION_UPDATE_PARTICIPANTS: "Teilnehmer",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK: "Personalisierten Link anzeigen",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "Die E-Mail-Adresse ist bereits hinterlegt und muss beim Öffnen nicht erneut eingegeben werden.",
    SAVE_SESSION_UPDATE_RECOMMENDED: "empfohlen",
    SAVE_SESSION_UPDATE_SUCCESS_TITLE: "Antragsentwurf erfolgreich gespeichert",
    SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "Den Link zum Entwurf haben wir an {emails} gesendet.",
    SAVE_SESSION_EMAIL_LIST_AND: "und",
    SAVE_SESSION_UPDATE_SUCCESS_SAVED: "Der Antragsentwurf wurde gespeichert.",
    SAVE_SESSION_UPDATE_SUCCESS_INVITE_HINT:
      "Laden Sie jetzt weitere Personen ein, falls gewünscht.",
    SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "Den Link zu Ihrem Entwurf haben wir an {email} gesendet.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "Ihren Entwurf finden Sie im Vertriebsportal unter {portalDraftsLink}. Den Link zu Ihrem Entwurf haben wir an {email} gesendet.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_NAV: "Anträge > Entwürfe",
    SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "Den Link zu Ihrem Antragsentwurf erhalten Sie binnen weniger Minuten. Bitte prüfen Sie Ihren Posteingang und ggf. Ihren Spam-Ordner.",
    SAVE_SESSION_SUCCESS_SHARE: "Entwurf teilen",
    SAVE_SESSION_SUCCESS_INVITE_MORE: "Weitere Personen einladen",
    SAVE_SESSION_SUCCESS_INVITE_MORE_SHORT: "Personen einladen",
    SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "Sie können Ihren Antragsentwurf teilen, sobald Sie den Link aus der E-Mail zu Ihrem Antragsentwurf öffnen.",
    SAVE_SESSION_SUCCESS_CONTINUE: "Antrag fortsetzen",
    SAVE_SESSION_SUCCESS_CONTINUE_SHORT: "Fortsetzen",
    SAVE_SESSION_OWNER: "Besitzer/-in",
    SAVE_SESSION_OWNER_INTRO:
      "Sie sind der/die Besitzer/-in dieses Antragsentwurfs. Sie können diesen Antragsentwurf ansehen, bearbeiten und absenden und erhalten einen Link per E-Mail.",
    SAVE_SESSION_OWNER_EMAIL: "E-Mail Besitzer/-in",
    SAVE_SESSION_OWNER_EMAIL_LABEL: "E-Mail-Adresse",
    SAVE_SESSION_OWNER_NAME: "Name Besitzer/-in",
    SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Für das Speichern Ihres Antragsentwurfs ist eine E-Mail-Adresse erforderlich, auf die Sie Zugriff haben. Den Link zum Öffnen Ihres Antragsentwurfs senden wir Ihnen im Anschluss per E-Mail.",
    SAVE_SESSION_ADD_PARTICIPANT: "Teilnehmer/-in hinzufügen",
    SAVE_SESSION_PARTICIPANT_DATE_TIME: "{date} um {time} Uhr",
    SAVE_SESSION_PERMISSION: "Berechtigung",
    SAVE_SESSION_PARTICIPANT_EMAIL_PLACEHOLDER: "E-Mail",
    SAVE_SESSION_PARTICIPANT_NAME_PLACEHOLDER: "Name",
    SAVE_SESSION_NAME_LABEL: "Name",
    SAVE_SESSION_NAME_EXAMPLE_PLACEHOLDER: "z. B. Max",
    SAVE_SESSION_PERMISSION_VIEW: "Ansehen",
    SAVE_SESSION_PERMISSION_VIEW_EDIT: "Ansehen + Bearbeiten",
    SAVE_SESSION_PERMISSION_VIEW_EDIT_SUBMIT: "Ansehen + Bearbeiten + Absenden",
    INVITATIO_RESUME_BOOKING_CONFIRM_KICKER: "Ihr Anfrageentwurf",
    INVITATIO_RESUME_BOOKING_CONFIRM_TITLE_PREFIXED: "Anfrageentwurf: {title}",
    INVITATIO_RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "Zum Schutz Ihres Anfrageentwurfs senden wir Ihnen einen Bestätigungscode per E-Mail.",
    INVITATIO_RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Geben Sie Ihre E-Mail-Adresse ein, die mit diesem Anfrageentwurf verknüpft ist. An diese E-Mail-Adresse senden wir Ihnen einen Einmal-Code für den Zugriff auf den Anfrageentwurf.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION:
      "Der gespeicherte Anfrageentwurf konnte nicht geladen werden.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "Der gespeicherte Anfrageentwurf wurde nicht gefunden oder gelöscht.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "Dieser gespeicherte Anfrageentwurf ist abgelaufen.",
    INVITATIO_RESUME_BOOKING_LOADER_TITLE:
      "Ihr Anfrageentwurf wird vorbereitet",
    INVITATIO_RESUME_BOOKING_LOADER_SUBTITLE:
      "Bitte warten Sie, während wir Ihren gespeicherten Anfrageentwurf laden.",
    INVITATIO_SAVE_SESSION_COMPLETED_LINK_LABEL: "Link zum Anfrageentwurf",
    INVITATIO_SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Gespeicherte Anfrageentwürfe werden automatisch nach 30 Tagen ohne Aktivität gelöscht.",
    INVITATIO_SAVE_SESSION_NOT_TRANSMITTED:
      "Die Anfrage wurde noch nicht an den zuständigen Versicherer übermittelt.",
    INVITATIO_SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Bitte beachten:</strong> Es handelt sich um einen gespeicherten Entwurf zu einer Versicherungsanfrage. Eine rechtsverbindliche Anfrage kommt erst zustande, wenn Sie die Anfrage über die Schaltfläche „{submitButton}“ absenden. Dieses Speichern begründet noch kein Vertragsverhältnis. Versicherungsschutz besteht erst, wenn die <strong>{insurerName}</strong> Ihre Anfrage ausdrücklich angenommen hat.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "Der vorgenannte Vermittler erhält Zugriff auf diesen von Ihnen gespeicherten Anfrageentwurf. Sie können diese Option jederzeit wieder deaktivieren.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER:
      "{brokerName} Zugriff auf meinen gespeicherten Anfrageentwurf gestatten",
    INVITATIO_SAVE_SESSION_NEW_INTRO:
      "Speichern Sie Ihre Anfrage als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link senden.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_BROKER:
      "Speichern Sie Ihre Anfrage als Entwurf. Geben Sie einen Titel ein – der Entwurf erscheint anschließend in Ihrer Entwurfsübersicht im Vertriebsportal.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Speichern Sie Ihre Anfrage als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link senden. Anschließend können Sie auch andere Personen zu Ihrem Anfrageentwurf einladen.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_INTRO:
      "Laden Sie weitere Personen ein, damit diese Ihre Anfrage als Entwurf ansehen, bearbeiten oder absenden können. Jede E-Mail-Adresse kann nur einmal verwendet werden.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_HELPER:
      "Alle Teilnehmer erhalten einen Link per E-Mail und können die Anfrage als Entwurf öffnen.",
    INVITATIO_SAVE_SESSION_MANAGE_TITLE: "Entwurf verwalten",
    INVITATIO_SAVE_SESSION_MANAGE_DESCRIPTION:
      "Möchten Sie Teilnehmer, Berechtigungen oder Zugriffslinks verwalten? Öffnen Sie dazu die Verwaltung der Anfrage als Entwurf.",
    INVITATIO_SAVE_SESSION_SHARE_TITLE: "Entwurf teilen",
    INVITATIO_SAVE_SESSION_SHARE_MENU_SHARE: "Anfrageentwurf teilen",
    INVITATIO_SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION:
      "Anfrageentwurf bearbeiten",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_TITLE: "Entwurf bearbeiten",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Ändern Sie Titel und Anmerkung Ihres gespeicherten Anfrageentwurfs.",
    INVITATIO_SAVE_SESSION_SAVE_TITLE: "Entwurf speichern",
    INVITATIO_SAVE_SESSION_TITLE_HELPER:
      "Wählen Sie einen einprägsamen Titel für Ihren Anfrageentwurf oder lassen Sie sich einen Titel vorschlagen. Den Titel Ihres Anfrageentwurfs können Sie später ändern.",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK:
      "Besitzer-Link zum Anfrageentwurf",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "Über diesen Link kann der/die Besitzer/-in den Anfrageentwurf direkt öffnen und verwalten.",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK:
      "Allgemeiner Link zum Anfrageentwurf",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Geben Sie eine in diesem Anfrageentwurf gespeicherte E-Mail-Adresse ein. Sie erhalten dann eine E-Mail an diese Adresse – über den Link in der E-Mail können Sie den Anfrageentwurf öffnen.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_TITLE:
      "Anfrageentwurf erfolgreich gespeichert",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "Den Link zum Entwurf haben wir an {emails} gesendet.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_SAVED:
      "Der Anfrageentwurf wurde gespeichert.",
    INVITATIO_SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "Den Link zu Ihrem Entwurf haben wir an {email} gesendet.",
    INVITATIO_SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "Ihren Anfrageentwurf finden Sie im Vertriebsportal unter {portalDraftsLink}. Den Link zu Ihrem Entwurf haben wir an {email} gesendet.",
    INVITATIO_SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "Den Link zu Ihrem Anfrageentwurf erhalten Sie binnen weniger Minuten. Bitte prüfen Sie Ihren Posteingang und ggf. Ihren Spam-Ordner.",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE: "Anfrageentwurf teilen",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "Sie können Ihren Anfrageentwurf teilen, sobald Sie den Link aus der E-Mail zu Ihrem Anfrageentwurf öffnen.",
    INVITATIO_SAVE_SESSION_SUCCESS_CONTINUE: "Anfrage fortsetzen",
    INVITATIO_SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "Die E-Mail-Adresse ist bereits hinterlegt und muss beim Öffnen des Anfrageentwurfs nicht erneut eingegeben werden.",
    INVITATIO_SAVE_SESSION_OWNER_INTRO:
      "Sie sind der/die Besitzer/-in dieses Anfrageentwurfs. Sie können diesen Anfrageentwurf ansehen, bearbeiten und absenden und erhalten einen Link per E-Mail.",
    INVITATIO_SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Für das Speichern Ihres Anfrageentwurfs ist eine E-Mail-Adresse erforderlich, auf die Sie Zugriff haben. Den Link zum Öffnen Ihres Anfrageentwurfs senden wir Ihnen im Anschluss per E-Mail.",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Anfrageentwurf speichern",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Speichern Sie Ihre Anfrage als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link zu Ihrem Anfrageentwurf senden.",
    INVITATIO_UPDATE_SESSION_ERROR_DESCRIPTION:
      "Der Anfrageentwurf konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",

    SEPA_VERIFICATION_SUCCESS_MESSAGE:
      "<p>Das SEPA-Lastschriftmandat zum Antrag mit der Kennung <strong>{bookingId}</strong> wurde für Sie hinterlegt.</p><p>Danke, dass Sie dem Einzug der Beiträge zugestimmt haben.</p><p>Ihr Vertrag kommt rechtswirksam ab dem ersten Beitrag zustande.</p>",
    SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "Ihr SEPA-Lastschriftmandat ist bereits bestätigt. Ihr Versicherungsantrag mit der Nummer <strong>{bookingId}</strong> ist erfolgreich bei uns eingegangen.",
    SEPA_VERIFICATION_ALREADY_VERIFIED_TITLE:
      "SEPA-Lastschriftmandat wurde bereits bestätigt",
    SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Bitte bestätigen Sie uns, dass die Beiträge per SEPA-Lastschrift von Ihrem Konto eingezogen werden dürfen. Klicken Sie dazu in der an <strong>{email}</strong> versandten E-Mail auf den vorgesehenen Bestätigungslink (z. B. <strong>„SEPA-Bestätigung“</strong>). Dabei beziehen wir uns auf Ihren Antrag <strong>{bookingData}</strong> bei <strong>{insurerName}</strong>. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ohne rechtzeitige SEPA-Mandatsbestätigung ist die Beitragseinziehung per Lastschrift nicht möglich. Ihr Antrag auf Abschluss Ihrer Versicherung wird von uns nur weiterverarbeitet, nachdem die Bestätigung erfolgreich erfolgt ist.",
    SEPA_VERIFICATION_BOOKING_PENDING_TITLE:
      "Bitte bestätigen Sie Ihr SEPA-Lastschriftmandat",
    SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Der Link zur Bestätigung Ihres SEPA-Lastschriftmandats zu Ihrem Antrag <strong>{bookingId}</strong> ist nicht mehr gültig. Ihr Antrag auf Abschluss Ihrer Versicherung wird in diesem Zusammenhang von uns nicht weiterverarbeitet.",
    SEPA_VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Bitte beachten Sie, dass der Bestätigungslink für das SEPA-Lastschriftmandat nur bis zum {date} um 23:59 Uhr gültig ist.</strong>",
    SEPA_VERIFICATION_SUCCESS_TITLE: "Bestätigung erfolgreich!",
    INVITATIO_WHAT_IS_NEXT: "So geht es weiter",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TITLE: "Anfrage stellen",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TEXT: "Ihre Anfrage ist bei uns eingegangen.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Bitte bestätigen Sie Ihre E-Mail über den Link in unserer Nachricht.",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "E-Mail bestätigen",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Bitte bestätigen Sie Ihre E-Mail-Adresse über den Link in der E-Mail, die wir an <strong>{email}</strong> gesendet haben. Erst danach leiten wir Ihre Anfrage weiter.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TITLE: "Anfrage prüfen",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_REQUEST_REVIEW_TEXT:
      "Wir prüfen Ihre Anfrage auf Vollständigkeit.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TEXT:
      "Wir prüfen Ihre Anfrage auf Vollständigkeit und Plausibilität.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TITLE: "Übermittlung",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_TRANSMISSION_TEXT:
      "Wir leiten Ihre Anfrage an den Versicherer weiter.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TEXT:
      "Wir leiten Ihre Anfrage an das gewählte Versicherungsunternehmen weiter.",
    INVITATIO_WHAT_IS_NEXT_POLICY_ISSUANCE_TITLE: "Policierung",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_POLICY_ISSUANCE_TEXT:
      "Der Versicherer bearbeitet Ihre Anfrage.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "Der Versicherer sendet Ihnen die Vertragsunterlagen.",
    INVITATIO_YOUR_CONTRACT_NUM: "Ihre Anfrage",
    IS_REQUIRED_FIELD: "Dies ist ein Pflichtfeld",
    IS_WRONG_FORMAT: "ist ungültig",
    I_HAVE_CONTRACT_TEXT_PART_4_COVOMO:
      "von {brandName} als Vermittler habe ich zur Kenntnis genommen und bin mit diesen einverstanden.",
    LEGAL_MATTERS: "Rechtliches",
    LINKOUT_APPLICANT_HEADING: "Antragssteller/-in",
    LINKOUT_DATE_PLACEHOLDER: "TT.MM.JJJJ",
    LINKOUT_INTRO_COMPARISON:
      "Sie verlassen nun den Vergleichsrechner und werden zur Online-Antragsstrecke des Produktgebers {insurer} weitergeleitet.",
    LINKOUT_INTRO_POLICYHOLDER:
      "Damit wir Ihren Antrag anschließend nachverfolgen und betreuen können, vervollständigen Sie bitte die nachfolgenden Angaben zum/zur Versicherungsnehmer/-in.",
    LINKOUT_INTRO_POLICYHOLDER_NO_SERVICE_APP:
      "Bitte vervollständigen Sie die nachfolgenden Angaben zum/zur Versicherungsnehmer/-in.",
    LINKOUT_OVERLAY_APPLICANT_DETAILS: "Angaben Antragsteller/-in",
    LINKOUT_OVERLAY_CLOSE_WINDOW: "Fenster schließen",
    LINKOUT_OVERLAY_REDIRECTING: "Sie werden weitergeleitet …",
    LINKOUT_PRIVACY_CONSENT:
      "Wenn Sie fortfahren, erklären Sie, die {privacyLink} des Produktgebers zur Kenntnis genommen zu haben und mit der Verarbeitung Ihrer Daten durch die {insurer} einverstanden zu sein.",
    LINKOUT_PRIVACY_LINK_TEXT: "Datenschutzbestimmungen",
    LINKOUT_QUOTE_COMPLETED: "Ihre Anfrage wurde abgeschlossen.",
    LINKOUT_QUOTE_INTRO_LINE:
      "Angebot für eine internationale Krankenversicherung",
    LINKOUT_REDIRECT_CLICK_HERE: "klicken Sie hier",
    LINKOUT_REDIRECT_COUNTDOWN:
      "Sie werden in {count} Sekunden weitergeleitet.",
    LINKOUT_REDIRECT_FALLBACK:
      "Falls die Weiterleitung nicht automatisch funktioniert, {link}.",
    LINK_HERE: "hier",
    MAIN_SERVICES: "Wichtigste Leistungen",
    MARKETING_AFFILIATE_CHECKBOX: `Sie sind gemäß Art. 15 DSGVO jederzeit berechtigt, von der {0} Auskunft zu den zu Ihrer Person gespeicherten Daten zu erhalten.
      Gemäß Art. 17 DSGVO können Sie darüber hinaus jederzeit die Berichtigung, Löschung und Sperrung einzelner personenbezogener Daten verlangen. Sie können darüber hinaus jederzeit ohne Angabe von Gründen von
      Ihrem Widerspruchsrecht Gebrauch machen und die erteilte Einwilligungserklärung mit Wirkung für die Zukunft abändern oder gänzlich widerrufen. Es entstehen Ihnen dabei keine anderen Kosten
      als die Übermittlungskosten nach den bestehenden Basistarifen. Widerspruch an: {1} oder an o.g. Adresse.
      Die vollständigen Datenschutzinformationen der {2} finden Sie `,
    MARKETING_CHECKBOX:
      "Ich willige ein, dass mir der Kooperationspartner von {brandName}, die {0}, {1}, {2}, per E-Mail Informationen und Angebote zu Versicherungsprodukten zum Zwecke der Werbung übermitteln kann.",
    MOBILE_FILTERS_MORE: "Mehr Filter",
    MOBILE_OVERLAY_FIND_TARIFFS: "Produkte finden",
    MOBILE_OVERLAY_SHOW_RESULTS:
      "{count} Ergebnis anzeigen | {count} Ergebnisse anzeigen",
    MOBILE_UPLOAD_FILE_REQUIRED_ERROR: "Bitte wählen Sie eine Datei aus.",
    MOBILE_UPLOAD_TITLE: "Dokument hochladen",
    MOBILE_UPLOAD_REFERENCE: "Antragsreferenz",
    MOBILE_UPLOAD_REQUIRED_DOCUMENT: "Benötigtes Dokument",
    MOBILE_UPLOAD_SELECT_FILE: "Datei auswählen",
    MOBILE_UPLOAD_FILE_HINT: "JPG, PNG oder PDF · maximal {maxSizeMb} MB",
    MOBILE_UPLOAD_CONFIRM: "Hochladen & Bestätigen",
    MOBILE_UPLOAD_UPLOADING: "Dokument wird hochgeladen …",
    MOBILE_UPLOAD_LOADING: "Upload-Link wird geladen …",
    MOBILE_UPLOAD_INTRO:
      "Ihr Antrag wurde erkannt. Bitte laden Sie das folgende Dokument hoch:",
    MOBILE_UPLOAD_SUCCESS:
      "Dokument erfolgreich übertragen. Sie können dieses Fenster schließen.",
    MOBILE_UPLOAD_INVALID: "Dieser Upload-Link ist ungültig.",
    MOBILE_UPLOAD_EXPIRED:
      "Dieser Upload-Link ist abgelaufen oder wurde bereits verwendet. Bitte öffnen Sie am Computer einen neuen QR-Code.",
    MOBILE_UPLOAD_LOAD_ERROR:
      "Der Upload-Link konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    MOBILE_UPLOAD_TYPE_ERROR:
      "Bitte wählen Sie eine JPG-, PNG- oder PDF-Datei aus.",
    MOBILE_UPLOAD_SIZE_ERROR:
      "Die ausgewählte Datei ist zu groß. Die maximale Dateigröße beträgt {maxSizeMb} MB.",
    MOBILE_UPLOAD_INFECTED_ERROR:
      "Die Datei konnte aus Sicherheitsgründen nicht angenommen werden. Bitte wählen Sie eine andere Datei.",
    MOBILE_UPLOAD_SERVER_ERROR:
      "Das Dokument konnte nicht übertragen werden. Bitte versuchen Sie es erneut.",
    MOBILE_UPLOAD_RETRY: "Erneut versuchen",
    MOBILE_UPLOAD_SELECT_ANOTHER: "Andere Datei auswählen",
    MULTISELECT_SELECTED: "{count} ausgewählt",
    NOT_INCLUDED: "Nicht enthalten",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_APPLICANT:
      "<p>Ich habe den Antrag eigenständig erstellt und das Produkt auf Grundlage eines konkreten Bedarfs selbst gewählt. Für die Produktwahl und die durchgeführte Online-Beratung wird ein Beratungsprotokoll erstellt. Auf eine persönliche Beratung sowie eine Beratung zu weiteren Versicherungsprodukten verzichte ich ausdrücklich.</p>",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_BROKER:
      "<p>Ich habe den Antrag im Auftrag des Kunden erstellt und das Produkt eigenständig gewählt, da ein konkreter Bedarf besteht. Für die Produktwahl und die durchgeführte Online-Beratung wird ein Beratungsprotokoll erstellt. Der Kunde verzichtet ausdrücklich auf eine persönliche Beratung sowie auf eine Beratung zu weiteren Versicherungsprodukten. Ich versichere, zur Abgabe dieser Erklärung durch den Kunden bevollmächtigt zu sein.</p>",
    NO_FILE_DETECTED: "Keine Datei ausgewählt",
    NO_OPTIONS_IN_SELECT: "Die Liste ist leer.",
    NO_TARIFFS: "Für die aktuelle Auswahl wurden keine Produkte gefunden.",
    ERSTINFORMATION_CONSENT_REQUIRED_BEFORE_SEARCH:
      "Bitte bestätigen Sie die Erstinformation, um die Produktsuche zu starten.",
    NO_TARIFFS_FOR_SELECTED_FILTERS:
      "Für die aktuelle Kombination aus Suchkriterien und Filtern wurden keine Produkte gefunden.",
    NO_TARIFFS_FOUND: "Es wurden keine Produkte gefunden",
    NO_VALUE_FOUND: "Keine Ergebnisse gefunden",
    OPTIONAL: "optional",
    PAGE_NOT_FOUND: "Seite nicht gefunden",
    PAGE_HEADING_ACCESSIBILITY: "Erklärung zur Barrierefreiheit",
    PAGE_HEADING_ASSESSMENT: "Risikoprüfung",
    PAGE_HEADING_BOOKING: "Antrag",
    PAGE_HEADING_BOOKING_COMPLETE: "Antrag abgeschlossen",
    PAGE_HEADING_BOOKING_REVIEW: "Antrag prüfen",
    PAGE_HEADING_BOOKING_STEP2: "Antrag – Zahlungsdaten",
    PAGE_HEADING_COMPARISON: "Produktvergleich",
    PAGE_HEADING_CONTRACT_RENEWAL: "Vertrag verlängern",
    PAGE_HEADING_DEFAULT: "Vergleichsrechner",
    PAGE_HEADING_NOT_FOUND: "Seite nicht gefunden",
    PAGE_HEADING_RESUME_BOOKING: "Antrag fortsetzen",
    PAGE_HEADING_SEARCH: "Tarifsuche",
    PAGE_HEADING_TARIFF: "Tarifdetails",
    PAGE_HEADING_VERIFICATION: "E-Mail-Verifizierung",
    PAGE_HEADING_WIZARD: "Bedarfscheck",
    PAGE_HEADING_STEP_BY_STEP: "Schritt für Schritt",
    PAGE_TITLE_ACCESSIBILITY: "Erklärung zur Barrierefreiheit {'|'} {siteName}",
    PAGE_TITLE_ASSESSMENT: "Risikoprüfung {'|'} {siteName}",
    PAGE_TITLE_BOOKING: "Antrag {'|'} {siteName}",
    PAGE_TITLE_BOOKING_COMPLETE: "Antrag abgeschlossen {'|'} {siteName}",
    PAGE_TITLE_BOOKING_REVIEW: "Antrag prüfen {'|'} {siteName}",
    PAGE_TITLE_BOOKING_STEP2: "Antrag – Zahlungsdaten {'|'} {siteName}",
    PAGE_TITLE_COMPARISON: "Produktvergleich {'|'} {siteName}",
    PAGE_TITLE_CONTRACT_RENEWAL: "Vertrag verlängern {'|'} {siteName}",
    PAGE_TITLE_DEFAULT: "{siteName} Vergleichsrechner",
    PAGE_TITLE_MOBILE_UPLOAD: "Dokument hochladen {'|'} {siteName}",
    PAGE_DESCRIPTION_MOBILE_UPLOAD: "Dokument sicher per Smartphone hochladen.",
    PAGE_TITLE_NOT_FOUND: "Seite nicht gefunden {'|'} {siteName}",
    PAGE_TITLE_RESUME_BOOKING: "Antrag fortsetzen {'|'} {siteName}",
    PAGE_TITLE_SEARCH: "Tarifsuche {'|'} {siteName}",
    PAGE_TITLE_TARIFF: "Tarifdetails {'|'} {siteName}",
    PAGE_TITLE_VERIFICATION: "E-Mail-Verifizierung {'|'} {siteName}",
    PAGE_TITLE_WIZARD: "Bedarfscheck {'|'} {siteName}",
    PAGE_TITLE_STEP_BY_STEP: "Schritt für Schritt {'|'} {siteName}",
    PAGE_DESCRIPTION_DEFAULT:
      "Vergleichen Sie Versicherungstarife und schließen Sie online ab – {brandName}.",
    PAGE_DESCRIPTION_SEARCH:
      "Tarife vergleichen, Leistungen prüfen und online abschließen – {brandName}.",
    PAGE_DESCRIPTION_WIZARD:
      "Finden Sie passende Versicherungsleistungen mit dem Bedarfscheck – {brandName}.",
    PAGE_DESCRIPTION_COMPARISON:
      "Vergleichen Sie ausgewählte Tarife und Leistungen im Detail – {brandName}.",
    PAGE_DESCRIPTION_TARIFF:
      "Tarifdetails, Leistungen und Preise im Überblick – {brandName}.",
    PAGE_DESCRIPTION_ASSESSMENT:
      "Risikoprüfung für Ihren Versicherungsantrag – {brandName}.",
    PAGE_DESCRIPTION_BOOKING:
      "Versicherungsantrag online ausfüllen und absenden – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_STEP2:
      "Zahlungsdaten für Ihren Versicherungsantrag eingeben – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_REVIEW:
      "Antrag prüfen und verbindlich absenden – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_COMPLETE:
      "Ihr Versicherungsantrag wurde erfolgreich übermittelt – {brandName}.",
    PAGE_DESCRIPTION_VERIFICATION:
      "E-Mail-Adresse für Ihren Versicherungsantrag bestätigen – {brandName}.",
    PAGE_DESCRIPTION_RESUME_BOOKING:
      "Unterbrochenen Versicherungsantrag fortsetzen – {brandName}.",
    PAGE_DESCRIPTION_NOT_FOUND:
      "Die angeforderte Seite wurde nicht gefunden – {brandName}.",
    PAGE_DESCRIPTION_ACCESSIBILITY:
      "Erklärung zur Barrierefreiheit dieses Vergleichsrechners – {brandName}.",
    SKIP_TO_CONTENT: "Zum Hauptinhalt springen",
    HEADER_NAV_LABEL: "Hauptnavigation",
    PAGE_NOT_FOUND_BUTTON: "Weiter zum Vergleich",
    PAGE_NOT_FOUND_TEXT:
      "Die von Ihnen gesuchte Seite konnte leider nicht gefunden werden oder der von Ihnen verwendet Link ist nicht länger gültig.",
    PARTIALLY_INCLUDED: "Enthalten (Hinweis beachten)",
    PAYER_FORM_TITLE: "Beitragszahler/-in",
    FILTER_CLEAR_SELECTION: "Auswahl aufheben",
    PAYMENT_INTERVAL_CLEAR_SELECTION: "Auswahl aufheben",
    PAYMENT_INTERVAL_REQUIRED: "Bitte wählen Sie eine Zahlungsweise.",
    PAYMENT_INTERVAL_TITLE: "Zahlungsweise",
    PAYMENT_INTERVAL_MONTHLY: "Monatlich",
    PAYMENT_INTERVAL_QUARTERLY: "Vierteljährlich",
    PAYMENT_INTERVAL_SEMIANNUAL: "Halbjährlich",
    PAYMENT_INTERVAL_ANNUAL: "Jährlich",
    PAYMENT_INTERVAL_ONCE: "Einmalbeitrag",
    PAYMENT_INTERVAL_WEEKLY: "Wöchentlich",
    PAYMENT_INTERVAL_DAILY: "Täglich",
    PAYMENT_INTERVAL_ANNUAL_TOTAL: "{price} / Jahr",
    PAYMENT_INTERVAL_SAVINGS: "Sie sparen {price} / Jahr",
    PAYMENT_INTERVAL_UNAVAILABLE: "Nicht verfügbar",
    PAYMENT_INTERVAL_UNAVAILABLE_TOOLTIP:
      "Diese Zahlungsweise wird für den berechneten Beitrag nicht angeboten – häufig weil der Beitrag unter dem Mindestbeitrag des Versicherers für diese Zahlweise liegt. Bitte wählen Sie eine der verfügbaren Zahlweisen.",
    PAYMENT_INTERVAL_CHEAPEST_TOOLTIP:
      "Günstigster Preis für das aktuell ausgewählte Produkt – bezogen auf die hier angezeigten, verfügbaren Zahlweisen dieses Produkts.",
    PAYMENT_METHOD: "Zahlungsart",
    PAYMENT_SECTION: "Zahlung",
    PLEASE_FILL_FIELD: "Bitte füllen Sie das Feld aus.",
    PLEASE_WAIT_CONTRACT_NUM:
      "Bitte warten Sie, bis Ihre Antragsnummer erstellt wurde.",
    PREMIUM_CALC_ERROR_BODY_P1:
      "Für die von Ihnen gemachten Angaben ist eine Berechnung der voraussichtlichen Versicherungsprämie nicht möglich.",
    PREMIUM_CALC_ERROR_BODY_P2_PREFIX:
      "Bitte versuchen Sie es erneut. Sollte der Fehler weiterhin bestehen, wenden Sie sich bitte an unseren Kundenservice unter ",
    PREMIUM_CALC_ERROR_BUTTON: "Zurück zur Produktübersicht",
    PREMIUM_CALC_ERROR_TITLE: "Fehler bei Prämienberechnung",
    PRICE: "Preis",
    PRICE_ASC: "€",
    PRICE_ASC_MOBILE: "Preis aufsteigend",
    PRICE_DESC: "€€€",
    PRICE_DESC_MOBILE: "Preis absteigend",
    PRICE_UPDATE_MODAL_ALERT_VARIANTS: {
      priceOnly: "Der Versicherungsbeitrag hat sich geändert.",
      contractOnlyToInquiry: "Dieses Produkt ist nun anfragepflichtig.",
      contractOnlyFromInquiry:
        "Dieses Produkt ist nicht mehr anfragepflichtig und kann direkt beantragt werden.",
      priceAndContractToInquiry:
        "Der Versicherungsbeitrag hat sich geändert und dieses Produkt ist nun anfragepflichtig.",
      priceAndContractFromInquiry:
        "Der Versicherungsbeitrag hat sich geändert und dieses Produkt kann nun direkt beantragt werden.",
    },
    PRICE_UPDATE_MODAL_ALERT_UNAVAILABLE:
      "Dieses Produkt kann mit Ihren aktuellen Angaben nicht abgeschlossen werden.",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON: "Neuen Beitrag bestätigen",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON_CONTRACT: "Änderungen bestätigen",
    PRICE_UPDATE_MODAL_IMPORTANT_LABEL: "Wichtiger Hinweis:",
    PRICE_UPDATE_MODAL_NEW_PREMIUM: "Neuer Beitrag",
    PRICE_UPDATE_MODAL_OLD_PREMIUM: "Alter Beitrag",
    PRICE_UPDATE_MODAL_RECALC_CONFIRM:
      "Bitte bestätigen Sie den neuen Beitrag, um fortzufahren.",
    PRICE_UPDATE_MODAL_RECALC_PREFIX:
      "Aufgrund Ihrer Eingaben wurde der Versicherungsbeitrag neu berechnet und beträgt nun ",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY:
      "Aufgrund Ihrer letzten Eingaben ist dieses Produkt nun anfragepflichtig.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY:
      "Bitte bestätigen Sie die Änderungen, um fortzufahren.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY:
      "Aufgrund Ihrer letzten Eingaben ist dieses Produkt nicht mehr anfragepflichtig und kann nun direkt beantragt werden.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY:
      "Bitte bestätigen Sie die Änderungen, um mit dem Antrag fortzufahren.",
    PRICE_UPDATE_MODAL_SENTENCE_DOT: ".",
    PRICE_UPDATE_MODAL_BODY_VARIANTS: {
      empty: [],
      priceOnly: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      contractOnlyToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY",
      ],
      contractOnlyFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY",
      ],
      priceAndContractToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      priceAndContractFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
    },
    PRICE_UPDATE_MODAL_TITLE_CHANGED: "Der Beitrag hat sich geändert",
    PRICE_UPDATE_MODAL_TITLE_CONTRACT_CHANGED:
      "Der Antragsstatus hat sich geändert",
    PRICE_UPDATE_MODAL_TITLE_UNAVAILABLE:
      "Dieses Produkt ist nicht mehr verfügbar",
    PRICE_UPDATE_MODAL_UNAVAILABLE_BODY:
      "Aufgrund Ihrer letzten Eingaben entspricht dieses Produkt nicht mehr den Annahmerichtlinien des Versicherers. Ein Abschluss ist daher aktuell nicht möglich.",
    PRINT: "Drucken",
    PRINT_RESULTS: "Drucken",
    PRINT_THIS_SITE: "Diese Seite drucken",
    PRODUCT_PROVIDER: "Produktgeber",
    REACH_US_TEXT: "Sie erreichen uns Mo-Fr 9-17 Uhr",
    RESET_FILTERS: "Alle Filter zurücksetzen",
    RISK_CARRIER: "Risikoträger",
    RISK_ZONE_COULD_NOT_BE_DETERMINED:
      "Die ZÜRS-Zone konnte nicht ermittelt werden.",
    SAVE: "Speichern",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Entwurf speichern",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Speichern Sie Ihren Antrag als Entwurf. Alles, was Sie dafür benötigen, ist eine E-Mail-Adresse, an die wir Ihnen einen persönlichen Link zu Ihrem Antrag senden.",
    FEATURE_HIGHLIGHT_DISMISS: "Verstanden",
    FEATURE_HIGHLIGHT_NEXT: "Weiter",
    FEATURE_HIGHLIGHT_STEP_OF: "Tipp {current} von {total}",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_TITLE: "Schnell vergleichen",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_BODY:
      "Hier finden Sie die Produkte aller Versicherer mit ihrem jeweils günstigsten Preis. Klicken Sie auf den Versicherer, um die Produkte dieses Versicherers anzuzeigen.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_TITLE: "Aktionen zum Tarif",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie den Tarif für ein Angebot aus, fügen Sie wahlweise einen Kommentar hinzu, wählen Sie mehrere Tarife für einen Vergleich oder drucken Sie alle Details zum gewünschten Tarif aus.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_COMPARE:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie den Tarif für ein Angebot aus, fügen Sie wahlweise einen Kommentar hinzu und wählen Sie mehrere Tarife für einen Vergleich.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_PRINT:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie den Tarif für ein Angebot aus, fügen Sie wahlweise einen Kommentar hinzu oder drucken Sie alle Details zum gewünschten Tarif aus.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie den Tarif für ein Angebot aus und fügen Sie wahlweise einen Kommentar hinzu.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE_PRINT:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie mehrere Tarife für einen Vergleich aus oder drucken Sie alle Details zum gewünschten Tarif aus.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Wählen Sie mehrere Tarife für einen Vergleich.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_PRINT:
      "An dieser Stelle finden Sie nun mögliche Aktionen zum Tarif: Drucken Sie alle Details zum gewünschten Tarif aus.",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_TITLE: "Zahlungsweisen unten",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_BODY:
      "Die Zahlungsweisen finden Sie jetzt unten in der Tarifleiste. Klicken Sie auf „Zahlungsweisen“, um alle Intervalle mit Jahresbeitrag und dem günstigsten Preis pro Zahlungsweise zu sehen.",
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_TITLE: "Ansicht anpassen",
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_BODY:
      "Passen Sie Darstellung, Kontrast und Schriftgröße über das Menü „Ansicht“ an.",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_TITLE: "Alle Dokumente auf einmal",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_BODY:
      "Laden Sie alle Unterlagen Ihres Antrags gesammelt als ZIP-Datei herunter.",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_TITLE: "Neu: Upload per Smartphone",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_BODY:
      "Scannen Sie den QR-Code und laden Sie Dokumente direkt vom Smartphone hoch – ohne erneute Anmeldung.",
    SAVE_SESSION_AUTO_TITLE_VALUE_INSURANCE: "{appName} für {value}",
    SAVE_SESSION_PARTICIPANT_STATUS_PENDING: "Ausstehend",
    SAVE_SESSION_PARTICIPANT_STATUS_INVITED: "Eingeladen",
    SAVE_SESSION_PARTICIPANT_STATUS_ACCEPTED: "Akzeptiert",
    SAVE_SESSION_PARTICIPANT_STATUS_OPENED: "Geöffnet",
    SAVE_SESSION_PARTICIPANT_LAST_OPENED: "Zuletzt geöffnet: {date}",
    SAVE_SESSION_PARTICIPANT_STATUS_OWNER: "Besitzer/-in",
    SAVE_SESSION_PARTICIPANT_ACCEPTED_AT: "Akzeptiert: {date}",
    SEALS_HEADING_INSURER: "Auszeichnungen für diese Gesellschaft",
    SEALS_HEADING_PRODUCT: "Auszeichnungen für dieses Produkt",
    SEALS_INDICATOR_LINK: "Auszeichnungen ({count})",
    SEALS_MORE_LINK: "+ {count} weitere …",
    SEARCHING_MATCHING_TARIFFS: "Produkte werden gesucht …",
    SEARCH_FORM_LOADING: "Suchmaske wird geladen …",
    SEARCH_MASK_DISMISS_BTN_SHORT_TXT: "Anpassen",
    SEARCH_MASK_DISMISS_BTN_TXT: "Suche anpassen",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_SHORT_TXT: "Fortfahren",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_TXT: "Mit Einstellungen fortfahren",
    SEARCH_MASK_ERROR:
      "Ihre Suche ergab keinen Treffer. Bitte füllen Sie alle Felder vollständig aus.",
    SEARCH_MASK_MODAL_TEXT_PART_ONE:
      "Sie haben noch keine Suchkriterien geändert.",
    SEARCH_MASK_MODAL_TEXT_PART_TWO:
      "Sie können die voreingestellten Kriterien übernehmen oder Ihre Suche anpassen, wenn Sie andere Wünsche haben.",
    SEARCH_OFFERS: "Angebote suchen",
    SEARCH_RESULTS_APPLIED_LABEL: "Angewandte Suchkriterien",
    SEARCH_RESULTS_PRINT_GENERATED: "Erstellt am {date}",
    SEARCH_RESULTS_PRINT_QR_ALT:
      "QR-Code mit Link zum aktuellen Vergleich (wie beim E-Mail-Versand)",
    SEARCH_RESULTS_PRINT_QR_HINT: "Link zur Seite",
    SHARE: "Teilen",
    TARIFF_PRINT_TITLE: "Tarif: {id} – {name}",
    TARIFF_PRINT_PREPARING: "Druckvorschau wird vorbereitet …",
    SEARCH_RESULTS_PRINT_TITLE: "Suchergebnisse",
    SEND: "Senden",
    SEND_EMAIL_INFO_BOLD:
      "Senden Sie diesen Vergleich per E-Mail – direkt an einen Kunden oder Kollegen.",
    SEND_EMAIL_INFO:
      "Die Empfängeradressen werden nicht gespeichert und nicht weitergegeben.",
    SEND_VIA_EMAIL: "Per E-Mail versenden",
    /** Toolbar / small screens keep full string in aria-label */
    SEND_VIA_EMAIL_SHORT: "Versenden",
    SEPA_ERROR_MESSAGE: "SEPA-Lastschriftmandat ist ein Pflichtfeld",
    SHARE_COMPARISON_EMAIL_ERROR_BODY:
      "Bitte prüfen Sie die E-Mail-Adresse oder versuchen Sie es später erneut.",
    SHARE_COMPARISON_EMAIL_ERROR_TITLE: "Ein Fehler ist aufgetreten",
    SHARE_COMPARISON_EMAIL_SUCCESS_BODY:
      "Der Link wurde an {email} verschickt.",
    SHARE_COMPARISON_EMAIL_SUCCESS_TITLE: "E-Mail erfolgreich gesendet",
    SHARE_COMPARISON_MODAL_TITLE: "Vergleich teilen",
    SHOW_ALL_COUNT: "Alle {count} anzeigen",
    SHOW_LESS: "Weniger anzeigen",
    SHOW_MORE_TARIFFS: "Mehr Ergebnisse anzeigen",
    SORT: "Sortieren",
    SORT_BY: "Sortieren nach:",
    PRODUCTS_FOUND: "{count} Produkt gefunden | {count} Produkte gefunden",
    PRODUCTS_FOUND_NONE: "Keine Produkte gefunden",
    SORT_TOGGLE_INSURER_HIGH: "Z",
    SORT_TOGGLE_INSURER_LOW: "A",
    SPECIAL_CONDITIONS_TEXT: "Bitte beachten Sie die besonderen Bedingungen",
    SPECIAL_FEATURES_AND_DEFINATIONS: "Besonderheiten und Definitionen",
    SPECIAL_FEATURES_TOOLTIP:
      "Unter Hinweise finden Sie wichtige Produkt- und Vertragsinformation die nicht Bestandteil unseres Detailvergleiches sind",
    TARIFF_ADDONS: "Zubuchbare Optionen",
    TARIFF_ADDONS_INTRO_TEXT:
      "Zu diesem Versicherungsprodukt sind nachfolgende Erweiterungsoptionen verfügbar. Die Erweiterungen können Sie im Antragsformular auswählen. Bitte beachten Sie, dass sich dadurch die ausgewiesene Versicherungsprämie ändern kann.",
    TARIFF_ADDONS_OVERVIEW_HEADING: "Zugebuchte Erweiterungen",
    TARIFF_BLOCK_BOOK_INQUIRY: "Jetzt anfragen",
    TARIFF_BLOCK_BOOK_INQUIRY_SHORT: "Anfragen",
    TARIFF_BLOCK_COVOMO_PLAN_SCORE: "Produktnote",
    TARIFF_BLOCK_COVOMO_RATING_GRADE: "befriedigend",
    TARIFF_BLOCK_MODAL_NOTICE_TITLE: "Hinweis",
    TARIFF_BLOCK_PAYMENT_HEADING: "Mögliche Zahlungsweisen",
    TARIFF_BLOCK_PAYMENT_INTRO:
      "Für das ausgewählte Produkt stehen folgende Zahlungsweisen zur Verfügung. Die endgültige Auswahl der Zahlungsweise erfolgt im letzten Schritt des Antragsformulars.",
    TARIFF_BLOCK_PAYMENT_OPTIONS_LOADING: "Zahlungsweisen werden geladen …",
    TARIFF_BLOCK_PRICE_ON_REQUEST: "auf Anfrage",
    TARIFF_BLOCK_REQUEST_QUOTE: "Angebot anfordern",
    TARIFF_BLOCK_SUBJECT_INQUIRY_BADGE: "anfragepflichtig",
    TARIFF_BLOCK_SUBJECT_INQUIRY_TOOLTIP:
      "Der Versicherer prüft diesen Antrag individuell. Bitte haben Sie Verständnis, dass die Entscheidung etwas Zeit in Anspruch nehmen kann.",
    TARIFF_CARD_FOOTER_ADDONS: "Optionen",
    TARIFF_CARD_FOOTER_COMPARE: "vergleichen",
    TARIFF_CARD_FOOTER_DETAILS: "Details",
    TARIFF_CARD_FOOTER_NOTES: "Hinweise",
    TARIFF_CARD_FOOTER_PAYMENT: "Zahlung",
    TARIFF_COMPARISON_SHOW_DIFFERENCES_ONLY: "Nur Unterschiede anzeigen",
    TARIFF_COMPARISON_SHOW_PAYMENT_OPTIONS: "Zahlungsweisen anzeigen",
    TARIFF_COMPARISON_SHOW_TOOLTIPS_INLINE: "Hinweistexte anzeigen",
    TARIFF_COMPARISON_LOADING: "Ihr Vergleich wird geladen …",
    TARIFF_DETAILS: "Produktdetails",
    TARIFF_MANAGER_BRAND_RATING: "{brandName} Bewertung: {score}",
    TARIFF_MANAGER_HOVER_SHOW_DETAILS: "Details anzeigen",
    TARIFF_MANAGER_LEGACY_ID: "ID: {id}",
    TARIFF_RIBBON_CHEAPEST_PRICE: "Günstigster Preis",
    TAX_INCLUDED: "inkl. Versicherungssteuer",
    THE_FORMAT_OF: "Das Format von",
    TIP: "Hinweise",
    TIP_SHOW: "Hinweise anzeigen",
    TOTAL_PRICE: "Gesamtpreis",
    TO_COMPARE: "Produkte vergleichen",
    TRAVELING_PEOPLE: "Alter Reisende Personen",
    TYPES_OF_INSURANCE: "Versicherungsarten",
    USEFUL_LINKS: "Weitere Informationen",
    BOOKING_LINK_COUNTRY_LABEL: "Land",
    BOOKING_LINK_COUNTRY_D: "Deutschland",
    BOOKING_LINK_COUNTRY_AT: "Österreich",
    BOOKING_LINK_COUNTRY_CH: "Schweiz",
    VERIFICATION_ALREADY_VERIFIED_P1:
      "Ihre E-Mail-Adresse wurde bereits bestätigt. Ihr Versicherungsantrag mit der Nummer <strong>{bookingId}</strong> ist erfolgreich bei uns eingegangen.",
    VERIFICATION_ALREADY_VERIFIED_P2:
      'Sollten Sie noch keine Bestätigung von uns per E-Mail erhalten haben, schauen Sie bitte auch in Ihrem Spam-Ordner nach oder kontaktieren Sie unseren Kundenservice unter <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_ALREADY_VERIFIED_TITLE:
      "Ihre E-Mail-Adresse wurde bereits bestätigt",
    VERIFICATION_BOOKING_PENDING_BODY:
      "Um uns abschließend mit der Weiterleitung Ihres Antrags mit der Nummer <strong>{bookingData}</strong> an die <strong>{insurerName}</strong> zu beauftragen, klicken Sie bitte auf den <strong>Link „E-Mail-Adresse bestätigen“</strong> in der E-Mail, die wir soeben an <strong>{email}</strong> gesendet haben. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ihr Antrag auf Abschluss einer Versicherung wird nur dann von uns weitergeleitet, wenn Sie die Bestätigung erfolgreich durchführen.",
    VERIFICATION_BOOKING_PENDING_TITLE:
      "Bitte bestätigen Sie Ihre E-Mail-Adresse",
    VERIFICATION_CONTACT_SUPPORT_DIRECT:
      'Bitte kontaktieren Sie unseren Kundenservice unter <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_CONTACT_SUPPORT_FOLLOWUP:
      'Sollte der Fehler bestehen bleiben, kontaktieren Sie bitte unseren Kundenservice unter <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Der Link zur Bestätigung Ihres Antrags mit der Nummer <strong>{bookingId}</strong> ist nicht mehr gültig. Ihr Antrag auf Abschluss einer Versicherung wird von uns nicht weiterverarbeitet.",
    VERIFICATION_EMAIL_CONFIRM_LINK_UNKNOWN:
      "Dieser Link zur Bestätigung einer E-Mail-Adresse ist uns nicht bekannt. Bitte prüfen Sie, ob Ihnen beim Öffnen oder Kopieren des Links ein Fehler unterlaufen ist.",
    VERIFICATION_LINK_EXPIRED_TITLE: "Dieser Link ist nicht mehr gültig",
    VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Bitte beachten Sie, dass dieser Link nur bis zum {date} um 23:59 Uhr gültig ist.</strong>",
    VERIFICATION_LINK_INVALID_TITLE: "Dieser Link ist fehlerhaft",
    VERIFICATION_RENEWAL_LINK_UNKNOWN:
      "Dieser Link zur Verlängerung eines Vertrages ist uns nicht bekannt oder nicht länger gültig. Bitte prüfen Sie, ob Ihnen beim Öffnen oder Kopieren des Links ein Fehler unterlaufen ist.",
    VERIFICATION_RELOAD_PAGE: "Seite neu laden",
    VERIFICATION_SERVICE_UNAVAILABLE_BODY:
      "Dieser Dienst ist momentan nicht erreichbar. Bitte laden Sie die Seite erneut. Sollte das Problem weiterhin bestehen, versuchen Sie es bitte später noch einmal.",
    VERIFICATION_SERVICE_UNAVAILABLE_TITLE: "Bestätigung derzeit nicht möglich",
    VERIFICATION_PRICE_UNAVAILABLE_BODY:
      "Der neue Beitrag konnte nicht ermittelt werden, weil die Daten Ihres Antrags nicht mehr aktuell sind und aktualisiert werden müssen.",
    VERIFICATION_LOADING: "Ihre Bestätigung wird geprüft …",
    VERIFICATION_POLICY_START_CHANGED_TITLE:
      "Versicherungsbeginn und Beitrag haben sich geändert",
    VERIFICATION_POLICY_START_CHANGED_BODY:
      "Der ursprünglich gewählte Versicherungsbeginn ist für diesen Tarif nicht mehr verfügbar. Ihr Antrag kann nur mit einem neuen Versicherungsbeginn und dem angepassten Beitrag fortgesetzt werden.",
    VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Erst nach Ihrer Bestätigung wird der Antrag weiterverarbeitet.",
    VERIFICATION_POLICY_START_OLD_LABEL: "Bisheriger Versicherungsbeginn",
    VERIFICATION_POLICY_START_NEW_LABEL: "Neuer Versicherungsbeginn",
    VERIFICATION_POLICY_START_OLD_PRICE_LABEL: "Bisheriger Beitrag",
    VERIFICATION_POLICY_START_NEW_PRICE_LABEL: "Neuer Beitrag",
    VERIFICATION_POLICY_START_CONFIRM_BUTTON:
      "Neuen Versicherungsbeginn und Beitrag bestätigen",
    VERIFICATION_POLICY_START_BOOKING_LABEL: "Antragsnummer: ",
    VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Bitte beachten:</strong> Wir weisen Sie darauf hin, dass Versicherungsschutz erst dann besteht, wenn Ihr Antrag auf Abschluss der Versicherung von der <strong>{insurerName}</strong> angenommen und bestätigt wird. Es gilt nur der in den Versicherungsbedingungen angegebene Versicherungsschutz. Die von uns ausgewiesenen Leistungsmerkmale werden nach bestem Wissen und Gewissen aktualisiert. Für Ihren Versicherungsvertrag gilt dennoch ausschließlich der in den Versicherungsbedingungen angegebene Leistungsumfang.",
    VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Ihr Versicherungsantrag mit der Nummer <strong>{bookingId}</strong> ist erfolgreich bei uns eingegangen. Sie erhalten von uns in Kürze eine Bestätigung per E-Mail an <strong>{policyHolderEmail}</strong>. Sollten Sie keine E-Mail erhalten, schauen Sie bitte auch in Ihrem Spam-Ordner nach.",
    VERIFICATION_SUCCESS_THANKS:
      "Vielen Dank für die Bestätigung Ihrer E-Mail-Adresse!",
    VERIFICATION_SUCCESS_TITLE: "Ihr Antrag wird nun von uns bearbeitet",
    WHAT_IS_NEXT: "So geht es weiter …",
    WHAT_IS_NEXT_SUBMIT_TITLE: "Antrag stellen",
    WHAT_IS_NEXT_SUBMIT_TEXT: "Ihr Antrag ist bei uns eingegangen.",
    WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Bitte bestätigen Sie Ihre E-Mail über den Link in unserer Nachricht.",
    WHAT_IS_NEXT_PROGRESS_SUBMISSION_TEXT:
      "Wir prüfen Ihren Antrag und leiten ihn weiter.",
    WHAT_IS_NEXT_PROGRESS_PROCESSING_TEXT:
      "Der Versicherer bearbeitet Ihren Antrag.",
    WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "Der Versicherer sendet Ihnen die Vertragsunterlagen.",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "E-Mail bestätigen",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Bitte bestätigen Sie Ihre E-Mail-Adresse über den Link in der E-Mail, die wir an <strong>{email}</strong> gesendet haben. Erst danach leiten wir Ihren Antrag weiter.",
    WHAT_DOES_IT_MEAN: "Was bedeutet das?",
    WIZARD_SELECT_PLACEHOLDER: "Bitte wählen …",
    WIZARD_FORM_COMPLETE_TOAST:
      "Bitte füllen Sie das Formular vollständig aus.",
    SBS_INTRO_HEADLINE: "In wenigen Schritten zur {calculatorName}",
    SBS_INTRO_HEADLINE_FALLBACK: "In wenigen Schritten zu Ihrem Angebot",
    SBS_INTRO_LEAD:
      "Beantworten Sie die folgenden Fragen – wir zeigen Ihnen passende Tarife zum Vergleich.",
    SBS_INTRO_BEFORE_START: "Bevor Sie starten",
    SBS_INTRO_LEGAL_HINT: "Beachten Sie die folgenden Hinweise:",
    SBS_INTRO_LEGAL_ACCORDION:
      "Falls Sie persönliche Daten von anderen Personen eingeben möchten",
    SBS_INTRO_THIRD_PARTY_DATA_NOTICE:
      "Falls Sie Daten von anderen Personen eingeben, beachten Sie bitte, dass die Personen (oder deren gesetzliche Vertreter:innen) damit einverstanden sind. Stellen Sie den betroffenen Personen auch unsere Datenschutzerklärung zur Verfügung.",
    SBS_INTRO_CTA: "Jetzt starten",
    SBS_BACK: "Zurück",
    SBS_PROGRESS: "{percent} %",
    SBS_DATA_PROCESSING:
      "Informationen zur Datenverarbeitung finden Sie {link}.",
    SBS_DATA_PROCESSING_LINK: "hier",
    SBS_OPEN_CALENDAR: "Kalender öffnen",
    SBS_DESIRED_START_DATE: "Wunschtermin",
    WIZARD_INITIAL_INFO_CHECKBOX_TEXT:
      "Ich bestätige, die Erstinformation für Versicherungsvermittler gemäß § 15 VersVermV heruntergeladen und gelesen zu haben.",
    WIZARD_INITIAL_INFO_REQUIRED:
      "Bitte bestätigen Sie den Erhalt der Erstinformation.",
    WIZARD_SUMMARY_EDIT: "Ändern",
    WIZARD_SUMMARY_TITLE: "Ihre Suche",
    UI_DISPLAY: "Ansicht",
    UI_DISPLAY_CURRENT: "Ansicht: {setting}",
    UI_THEME_CYCLE_TO: "Farbschema wechseln zu {mode}",
    UI_THEME_LIGHT: "Hell",
    UI_THEME_DARK: "Dunkel",
    UI_THEME_AUTO: "Automatisch",
    UI_THEME_HIGH_CONTRAST_ENABLE: "Hoher Kontrast",
    UI_THEME_HIGH_CONTRAST_DISABLE: "Normaler Kontrast",
    UI_CONTRAST_TOGGLE_TO: "Kontrast wechseln zu {mode}",
    UI_FONT_SIZE_LEVEL_0: "Standard",
    UI_FONT_SIZE_LEVEL_1: "Vergrößert",
    UI_FONT_SIZE_LEVEL_2: "Maximal",
    UI_FONT_SIZE_CYCLE_TO: "Schriftgröße wechseln zu {size}",
    UI_LOADING: "Wird geladen …",
    UI_FONT_SIZE_INCREASE: "Schrift vergrößern",
    UI_FONT_SIZE_DECREASE: "Schrift verkleinern",
    UPDATE_SESSION_SUCCESS_DESCRIPTION: "Ihre Änderungen wurden gespeichert.",
    UPDATE_SESSION_SUCCESS_TITLE: "Änderungen gespeichert",
    UPDATE_SESSION_ERROR_DESCRIPTION:
      "Der Antragsentwurf konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    CONTACT_WIDGET_DROPDOWN_TITLE: "Ihre Ansprechpartner",
    LIVE_CHAT_OPEN_LABEL: "Live-Chat öffnen",
    CONTACT_WIDGET_TOGGLE_LABEL: "Kontaktinformationen ein- oder ausblenden",
    CONTACT_WIDGET_EMAIL_LABEL: "E-Mail",
    CONTACT_WIDGET_PHONE_LABEL: "Telefon",
    CONTACT_WIDGET_PHOTO_ALT: "Kontaktbild",
    CONTACT_WIDGET_WEBSITE_LABEL: "Webseite",
    YOUR_CONTACT_PERSON: "Ihr Ansprechpartner",
    YOUR_CONTRACT_NUM: "Ihr Antrag",
    YOUR_DOCUMENTS: "Ihre Dokumente",
    YOUR_RECORDS: "Ihre Unterlagen",
    YOUR_SELECTION: "Ihre Auswahl",
    YOUR_SEARCH_SELECTION: "Ihre Suchauswahl",
    MCP_WIDGET_BEST_OFFERS: "Beste Angebote",
    MCP_WIDGET_BOOK: "Bei {brandName} abschließen",
    MCP_WIDGET_BOOK_MESSAGE:
      "Ich möchte den Tarif {tariff} von {insurer} abschließen.",
    MCP_WIDGET_DETAILS: "Details",
    MCP_WIDGET_PRICE_ON_REQUEST: "Preis auf Anfrage",
    MCP_WIDGET_ALL_SET: "Alle Angaben sind erfasst",
    MCP_WIDGET_OPEN_SUMMARY: "Auf {brandName} fortsetzen",
    MCP_WIDGET_IMPORTANT: "Wichtig",
    MCP_WIDGET_CHECK_NOTICE:
      "Bitte prüfen Sie vor dem Abschluss auf {brandName} noch einmal alle Angaben. Sie sind die Grundlage Ihres Versicherungsschutzes – falsche oder unvollständige Angaben können ihn gefährden.",
    MCP_WIDGET_CODE_NOTICE:
      "Zum Öffnen senden wir Ihnen einen Bestätigungscode per E-Mail.",
  },
};
